var _defs, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _polyline, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 365.62 360.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.7,212.71c-.33.24-.17.59-.17.88.11,6.81-.04,13.61-.25,20.41-.29,9.44-.26,18.89-.67,28.33-.4,9.09-.78,18.18-1.13,27.27-.21,5.58.14,11.17-.31,16.72-.51,6.4-.3,12.79-.23,19.18.04,3.69.37,7.39.1,11.09-.03.47.2.98-.17,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.71,222.56c.43,1.92.26,3.88.3,5.81.12,7.8.46,15.6.2,23.4-.18,5.46.08,10.92-.17,16.36-.45,9.73-.42,19.48-.76,29.21-.36,10.27-.07,20.53-.28,30.8-.03,1.54.11,3.14-.69,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.43,59.45c.52,3.05.07,6.11-.06,9.15-.12,2.76,0,5.52-.25,8.28-.2,2.1-.37,4.21-.4,6.33-.02,1.16-.56,2.1-1.75,2.45-1.08.32-1.67,1.48-2.99,1.48-.59,0-.54.92-.53,1.52.09,5.22-.08,10.44-.21,15.66-.21,8.39-.47,16.78-.73,25.16-.11,3.4-.18,6.81-.31,10.21-.34,9.27-.58,18.54-1,27.8-.17,3.87-.33,7.74-.42,11.61-.21,9.45-.67,18.88-.91,28.33-.04,1.42.03,2.82.05,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.43,232.77c4.5,1.22,9.16,1.61,13.73,2.43,4.1.73,8.23,1.34,12.3,2.22,5.21,1.12,10.44,2.11,15.68,3.06,5.03.91,10.08,1.72,15.12,2.56,4.18.7,8.35,1.49,12.51,2.36,4.82,1,9.61,2.14,14.43,3.15,3.79.79,7.58,1.62,11.42,2.19,3.12.47,6.33.94,8.76,3.19.95.88,3.03,1.02,3.03,1.02,0,0,14.86,2.72,18.48,3.15,1.06.13,1.36.77,1.2,1.59-.15.75-.33,1.41.39,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.16,227.49c.13,7.28-.33,14.54-.43,21.82-.1,7.09-.48,14.19-.67,21.29-.18,6.39-.58,12.78-.69,19.18-.08,4.93-.33,9.85-.49,14.78-.02.69-.15,1.29-.7,1.77-.3.26-.71.6-.43,1.03.23.34.69.4,1.12.37,1.88-.14,3.76-.25,5.63-.41,4.16-.35,8.33-.72,12.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.78,108.54c-2.68.93-4.71,2.91-7.02,4.43-5.65,3.73-11.37,7.34-16.91,11.23-2.8.36-2.44,2.4-2.49,4.4-.22,9.45-.3,18.92-1.24,28.33-1.83,18.21-1.82,36.46-1.77,54.73,0,4.04-.02,8.1-.16,12.14-.04,1.27-.47,2.52-1.38,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.52,120.51c-1.39-.06-2.25,1.35-3.7,1.28-.57-.03-.53.59-.58,1.18-.31,3.52-.16,7.05-.25,10.56-.25,9.85-.41,19.71-.65,29.56-.13,5.34-.08,10.68-.31,16.01-.33,7.51-.03,15.03-.41,22.52-.29,5.64.04,11.28-.43,16.9-.09,1.13-.73,1.7-1.76,1.4-4.21-1.2-8.58-1.58-12.85-2.46-3.21-.66-6.44-1.24-9.68-1.75-.59-.09-1.2-.15-1.58-.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.08,197.22c-1.37-.01-1.39,1-1.4,1.94-.03,2.05-.05,4.11,0,6.16.1,4.34-.3,8.68-.18,13.02.01.56-.02,1.11-.35,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.56,272.89c-.91,1.49.03,3.04-.13,4.58-.2,1.82-.05,1.71-1.98,1.6-4.47-.25-8.92-.63-13.37-1.06-4.82-.46-9.62-1.05-14.42-1.62-3.05-.37-6.11-.55-9.15-.91-4.34-.51-8.7-.72-13.03-1.34-1.45-.21-2.94-.24-4.4-.31-3.82-.18-7.61-.79-11.43-.77-1.18,0-2.35-.11-3.53.32-2.33.85-4.41-.11-6.51-1.02-9.06-3.92-18.35-7.26-27.45-11.08-1.18-.5-1.66-.94-1.68-2.48-.04-4.22-.04-8.45-.07-12.67-.06-8.39.56-16.77.34-25.16-.01-.4-.06-.8.35-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.63,241.74c-1.56-.5-1.45-2.46-2.79-3.22-.3-.17-.6-.67-.92-1-.81-.87-1.39-.95-2.32.13-3.09,3.57-4.85,7.77-6.31,12.17-1.67,5.04-1.8,10.29-2.27,15.49-.77,8.54-.8,17.13-1.3,25.69-.2,3.52-.07,7.05-.46,10.56-.03.27.18.49.34.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.1,135.46c0-6.39-2.55-11.39-8.29-14.4-4.41-2.32-10.07-.27-11.95,4.9-2.96,8.14,2.04,17.45,9.5,19.71,4.04,1.22,7.46-.49,9.11-3.54,1.06-1.97,2.15-4.07,1.45-6.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.59,338.87c-2.02-.71-2.45-2.14-2.54-4.22-.25-5.69.21-11.39-.3-17.07-.19-2.1-.02-4.31-1.39-6.16-.74-1.01-1.08-.99-1.58.18-.71,1.69-.64,3.51-.68,5.28-.16,6.52.17,13.02.48,19.53.04.81.25,1.15,1.08,1.06.82-.1,1.71.23,2.46-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.92,332.54c.94.6,1.99.35,2.99.32.72-.02.52-.73.52-1.2.01-3.4,0-6.8,0-10.21s.05-6.8-.02-10.21c-.04-1.71-.34-3.4-1.51-4.91-2.39,2.23-2.01,5.1-2.12,7.73-.25,5.98.1,11.96-.16,17.95-.06,1.36-.85,1.51-1.65,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.43,306.14c1.2,1.09,1.59,2.48,1.59,4.05-.01,7.1,0,14.19-.01,21.29,0,.72.37,1.82-1.04,1.57-.89-.16-1.97.18-2-1.57-.11-7.16-.11-14.31-.12-21.47,0-1.38.15-2.69,1.24-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.7,250.54c.65.16.96.79,1.01,1.24.38,3.07,1.15,6.09,1.36,9.15.09,1.34-.79,2.74-.62,4.22.05.41-.17,1.01.04,1.2,1.27,1.16,1.07,2.64,1.01,4.08-.04.97.75,1.13,1.26,1.18.75.06.49-.71.52-1.18.03-.47-.05-.95.02-1.4.09-.57-.49-1.56.69-1.56.93,0,2.04-.19,2.16,1.38.05.69.39,1.38.3,2.11-.11.95.49,1.41,1.23,1.36.68-.05.86-.66.55-1.37-.13-.29-.04-.7-.02-1.05.04-.76-.3-1.84,1.05-1.74,1.04.08,2.24.09,2.13,1.74-.05.69-.17,1.41.14,2.12.3.68.81.79,1.42.69.77-.13.45-.77.54-1.22.05-.24-.18-.32-.2-.53-.11-.9-.38-1.87.9-2.1,1.32-.24,2.65.61,2.8,1.75.09.65.09,1.29.3,1.95.22.7.71.79,1.12.82.57.04.76-.45.71-1.02-.04-.41-.06-.83,0-1.23.09-.55-.4-1.56.51-1.51.71.04,1.83-.02,2.13,1.15.17.65.17,1.29.16,1.94-.02.88.53,1.01,1.24,1.07.87.08.89-.42.89-1.07,0-2.57-.2-5.11-1.06-7.57-.18-.52.11-1.05.18-1.58.29-2.05.53-4.11.84-6.16.07-.44.35-.6.55-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.74,290.66c-1.27-.29-2.48.22-3.69.41-1.12.18-1.43-.05-1.43-1.11,0-4.52.47-9.03.51-13.55.02-3.12.35-6.22.36-9.33,0-4.46.33-8.91.37-13.37,0-.7.45-1.19.67-1.78.59-1.58,1.36-3.14,1.28-4.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.9,244.73c.23-1.52-.09-3.06.26-4.58.39-1.7-1.27-2.24-1.95-3.33-.95-1.51-2.25-3.09-3.87-3.4-1.8-.34-2.5,1.83-3.47,3.06-5.21,6.54-8.15,14.05-9.17,22.33-.24,1.99.1,4.02.05,5.98-.1,3.81.42,7.66-.41,11.44-.04.17,0,.35,0,.53.07,4.94-.47,9.85-.53,14.78-.05,3.94-.5,7.85-.56,11.79-.02,1.15.29,1.45,1.44,1.45,2.07,0,4.14-.11,6.15-.45,2.11-.36,4.28.04,6.35-.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M111.1,72.47c.52.25.43.85.71,1.23.71.97.54,1.84-.54,2.25-.86.32-2.05.75-2.41-.68-.18-.71-.73-.94-1.09-1.4-.42-.52-1.02-1.25-.81-1.72.28-.64.56-1.03-.26-1.24-.6-.16-.91.52-1.01.87-.43,1.43-1.12,2.72-1.01,4.39.14,2.32-.29,4.67-.3,7.03-.02,3.34.16,6.72-.07,10.02-.24,3.36.22,6.69-.18,10.04-.27,2.26.02,4.57-.23,6.86-.07.61,0,1.16.7,1.41,3.66,1.33,7.27,2.78,10.73,4.58.68.35.89.07.88-.54-.08-3.05.26-6.11.15-9.15-.17-4.81-.13-9.62,0-14.43.1-3.75.42-7.48-.05-11.27-.44-3.55-1.13-6.9-2.87-10.04-.19-.33-.34-.73-.58-1.03-.69-.85-1.21-2.42-2.42-2.03-1.52.49-3.16,1.31-3.55,3.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.46,80.91c-.42,2.45-.08,4.93-.15,7.39-.1,3.4-.49,6.79-.38,10.21.04,1.29.24,2.64-.05,3.86-.33,1.36.36,1.81,1.3,2.11,3.77,1.22,7.48,2.55,10.91,4.58,1.29.76,1.5.54,1.58-1.04.37-6.86.15-13.73.42-20.58.18-4.7.33-9.39.23-14.08-.09-4.32-1.54-8.28-4.38-11.6-1.7-1.99-3.78-1.64-5.08.69-.38.68-.93,1.16-1.58,1.59-1.18.79-1.67,2.06-1.92,3.34-.6,3.13-.88,6.32-1.02,9.5-.05.98.19,1.98-.04,2.99-.13.6.24,1.02.86,1.04.84.03,1.61.44,2.25.78,1.37.73,1.4-.23,1.42-.95.07-2.64.02-5.28.04-7.92,0-.64-.02-1.03-.88-1.1-.96-.07-1.94-.37-2.82-.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.7,80.65c1.28-2.6.14-7.47-2.12-8.87-.52-.32-1.03-.31-1.6.3-1.74,1.86-2.27,4.21-2.76,6.55-.7,3.36-1.17,6.76-1.49,10.19-.55,5.86-.44,11.74-.74,17.6-.18,3.58-.16,7.16-.24,10.74-.01.7-.46,1.73.36,2.04.65.25,1.65-.47,2.02-.87,1.69-1.85,3.93-2.88,5.9-4.3.72-.52.86-1.03.86-1.8-.02-8.8.58-17.59.35-26.39-.04-1.64.63-3.31-.18-4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.06,303.68c-.71.87-.7,1.94-.91,2.98-.9,4.43-1.33,8.84-.76,13.39.3,2.36.43,4.8.41,7.2-.02,2.78.4,5.51.58,8.27.05.83.34,1.45,1.57,1.1,2.05-.57,4.21-.13,6.33-.37,2.49-.28,2.72-.35,2.63-2.85-.23-6.39-.37-12.79-.58-19.18-.15-4.38-1.09-8.68-3.08-12.68-.54-1.09-1.15-2.05-2.11-2.83-.43-.35-1.11-.46-1.21-.3-.81,1.38-2.56,2.25-2.33,4.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.37,65.25c-1.02-.42-1.5-1.44-2.29-2.1-.49-.4-.83-.45-1.44.13-2.48,2.39-3.21,5.51-3.81,8.66-.65,3.42-.85,6.9-1.14,10.37-.56,6.74-.63,13.49-.68,20.24-.01,1.7-.14,3.4-.14,5.1,0,1.18-.05,2.35.17,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.9,297.7c-1.48-.17-1.82.61-1.78,1.94.26,7.15.64,14.3.75,21.47.11,7.57.46,15.13.68,22.7,0,.06.11.12.17.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.35,309.31c4.67,3.85,6.89,9.03,8.1,14.78.91,4.36.88,8.79,1.02,13.2.2,6.16.52,12.31.54,18.47,0,.28.21.45.19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.6,296.46c1.22.69,1.63.36,1.61-1.06-.08-4.63.02-9.27-.18-13.9-.05-1.12-.26-1.68-1.6-1.81-2.58-.26-5.16-.46-7.75-.66-.82-.06-1.31.06-1.24,1.07.33,4.86.15,9.74.18,14.6,0,.76.31,1.36,1.06,1.39,2.59.09,5.16.32,7.74.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.89,300.51c.23,6.87.52,13.73,1,20.59.39,5.67.69,11.37.85,17.06.1,3.28.43,6.56.44,9.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.41,298.4c.38,1.15.31,2.38.29,3.52-.05,2.95.27,5.88.48,8.79.53,7.39.47,14.79.93,22.18.19,3.04.34,6.09.42,9.15.02.66-.2,1.37.35,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.13,339.22c1.11-.09,2.23.1,3.35-.15.94-.21,1.46-.64,1.4-1.61-.36-5.04-.14-10.09-.44-15.14-.16-2.61.13-5.28-.1-7.91-.4-4.49-1.23-8.86-4.2-12.49-1.18-1.44-1.52-1.44-2.45.18-.53.93-1.17,1.81-1.6,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.37,296.29c1.54-.74,3.17-.3,4.75-.31,1.15,0,1.46-.3,1.44-1.45-.09-5.16-.39-10.32-.36-15.48,0-.82-.26-1.02-1.07-1.08-4.35-.36-8.69-.8-13.03-1.36-1.4-.18-2.83.07-4.23-.34-.69-.2-1.03.24-1.07,1.03-.09,1.89.16,3.75.21,5.63.09,3.34-.4,6.67-.06,10.03.27,2.62.12,2.66,2.85,2.63,3.48-.05,6.93.29,10.38.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.55,294.62q1.36-1.11-.26-2.63c-4.58,4.19-6.84,9.45-7.31,15.56-.67,8.74-.36,17.48-.2,26.22.01.61-.16,1.28-.86,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.69,306.49c.4.77.75,1.57.7,2.46-.05.92.47,1.07,1.24,1.07.78,0,1.03-.45,1.04-1.07.03-1.64,0-3.28.01-4.93,0-.64-.43-1.02-.9-1.2-.48-.18-.85.22-1.04.67-.98,2.35-2.33,4.44-2.6,7.2-.38,3.88-.71,7.75-.52,11.62.28,5.81-.12,11.62.27,17.42.07.97.27,1.35,1.26,1.24,3.57-.4,7.19-.35,10.74-1.04.68-.13,1.42-.11,2.1,0,1.47.25,1.99-.5,1.93-1.78-.13-2.7.4-5.42-.33-8.1-.03-.11,0-.23,0-.35.18-4.06-.45-8.08-.4-12.14.04-3.87-.13-7.76-1.69-11.45-1.07-2.52-2.6-4.67-4.6-6.5-.85-.77-1.8-.96-2.62,0-.86,1.01-2.38,1.45-2.65,2.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.12,122.27c-5.11-2.04-10.22-4.07-15.32-6.12-7.24-2.9-14.52-5.68-21.81-8.48-1.92-.74-3.72-1.82-5.8-2.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M312.22,299.1c.27,5.93.62,11.85,1.01,17.77.2,2.92.27,5.87.34,8.8.13,5.4.36,10.79.52,16.19.04,1.33-.05,2.7-.12,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.97,210.07c.37,1.57.26,3.18.14,4.75-.38,4.98-.39,9.98-.72,14.96-.31,4.7-.22,9.39-.32,14.08-.04,1.78.14,3.49.9,5.1,1.03,2.19.37,4.46.33,6.69-.1,5.28-.25,10.57-.59,15.83-.35,5.4.07,10.81-.59,16.2-.22,1.82.76,3.45,1.42,5.08.27.68.32,1.26.33,1.95.09,4.99-.21,9.98-.44,14.95-.38,7.98-.75,15.95-.76,23.93,0,3.44-.75,6.78-.83,10.2-.06,2.57,0,5.18-.58,7.76-.31,1.35.46,1.89,1.89,1.75,3.4-.34,6.77-.95,10.21-.91,1.48.02,2.67-1.21,4.22-1.24.87-.02,1.76-.16,2.64-.14,5,.1,9.97-.52,14.95-.76,3.05-.15,6.11-.4,9.14-.74,1.81-.2,3.67.03,5.48-.57,1.61-.53,3.18.4,4.72.74,3.57.77,7.16,1.41,10.74,2.07,3.76.69,7.52,1.34,11.26,2.1,4.1.84,8.24,1.52,12.33,2.42.54.12,1.06.08,1.22.73.26,1.07,1.07.97,1.93,1.09,2.81.39,5.63.31,8.45.32,1.09,0,2.09.13,1.3-1.61-.4-.88-.08-2.08-.07-3.14.02-1.24-.03-2.42-1.04-3.37-.33-.31-.42-.83-.4-1.39.08-2.11,0-4.22.03-6.33.07-5.76-.45-11.49-.52-17.24,0-.23-.28-.3-.19-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.95,348.72c.73-.82.65-1.84.69-2.82.05-1.23.11-2.47-.01-3.69-.17-1.62.18-3.07,1.46-4.01,1.37-1,1.4-2.32,1.38-3.73-.09-5.4.18-10.8.46-16.18.23-4.4.12-8.81.51-13.21.25-2.84.29-5.74.26-8.61,0-.97.04-1.83,1.41-1.42.21.06-.06.04.17,0,1.05-.13,2.27-.88,3.12-.12.96.87.39,2.3.38,3.46-.12,7.45-.22,14.91-.57,22.34-.25,5.4-.47,10.79-.46,16.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.18,302.62c.14.22-.32.84.35.69,1.38-.3,1.63.66,1.94,1.6.96,2.92,1.45,5.94,1.55,8.98.25,7.51.79,15.01.71,22.52,0,.8.41,1.24.92,1.56.91.57,1.23.12,1.23-.85-.02-3.34-.11-6.69-.25-10.03-.12-2.82-.03-5.63-.25-8.45-.37-4.8-.32-9.65-1.99-14.24-.67-1.85-1.47-3.69-3.08-5-.97.41-1.08,1.71-2.18,1.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.05,310.01c-.29-6.7-1.75-12.99-6.89-17.74-3.1-2.86-3.29-3.46-6.45.53-3.19,4.04-5.07,8.75-5.86,13.87-.1.65-.42,1.25-.35,1.94.08.83-.5.76-1.05.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.44,205.49c2.36.2,4.66.83,6.83,1.66,1.46.56,2.11,2.23,2.11,3.8-.02,4.46-.05,8.93-.49,13.37-.03.29-.01.59,0,.88.2,7.04-.54,14.07-.4,21.12.04,1.83,1.01,3.33,1.18,5.09.06.61.26,1.29.27,1.94.07,10.39-.72,20.76-.76,31.14,0,2.99-.26,5.9,1.27,8.64.24.43,0,1.04.02,1.57.19,4.4.5,8.81-.17,13.2-.02.11,0,.23,0,.35.02,8.68-.6,17.36-.37,26.04,0,.27.21.45.19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.97,251.6c.49.76-.07,1.52-.03,2.29.09,1.76-.01,3.52.03,5.28.26,9.57-.52,19.12-.36,28.68.01.84-.17,1.65-.35,2.46-.4,1.8-1.58,3.15-2.64,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.1,337.29c5.25-.36,10.4-1.62,15.66-1.73,2.88-.06,5.75.39,8.62.69,3.12.33,6.22-.12,9.33-.19,3.46-2.34,7.4-.96,11.09-1.34,6.66-.68,13.37-.82,20.05-1.27,2.58-.17,5.16-.33,7.74-.56,1.15-.1,1.89.94,2.33,2.62.31,1.19.3,2.35.31,3.53.02,1.47.13,2.94.12,4.4,0,1.41.45,1.78,1.81,1.98,4.39.64,8.8,1,13.21,1.35,5.69.45,11.38.96,17.06,1.46,1.46.13,2.96.06,4.41.47,2.82.8,5.72.76,8.62.73.83,0,1.64-.14,2.46-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.95,300.34c.06-8.34.58-16.66,1.02-24.99.15-2.81.23-5.65-.32-8.44-.12-.59-.19-1.35-.88-1.35-.5,0-.89.55-1.09,1.17-.17.5-.18,1.18-.85,1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.49,210.42c-.39,1.8-.3,3.66-.29,5.45.04,8.28-.51,16.54-.62,24.81-.02,1.76-.11,3.52-.14,5.28,0,.23.08.5-.01.7-.37.8-.57,1.66-.91,2.45-.92,2.15-3.38,3.26-5.76,2.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.71,335.7c-1.86.43-3.77.27-5.63.3-9.92.16-19.81,1.23-29.74,1.11-.75,0-1.47.11-2.11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.81,348.9c.22-1.26-.33-2.45-.37-3.69-.03-.8-.61-1.04-1.39-1.07-1.43-.05-2.82.28-4.22.43-5.22.53-10.45,1.07-15.66,1.75-4.46.58-8.96.85-13.39,1.68-1.02.19-2.12-.03-3.16.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.81,133.17c.29.49.26,1.04.27,1.58.22,8.63-.51,17.24-.41,25.87.03,2.45-.07,4.93-.11,7.39-.02.98-.17,1.52-1.39,1.83-2.15.54-3.94,1.85-4.95,3.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.12,263.91c-4.51-.77-9.03-1.48-13.56-2.04-4.15-.52-8.31-1.11-12.48-1.53-3.53-.36-7.04-.92-10.56-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.23,292.77c-.65-.87-.38-1.88-.33-2.81.32-5.86.52-11.73.86-17.6.14-2.41.47-4.81-.15-7.22-.14-.53-.08-1.17-.74-1.18-.46,0-.66.55-.92.99-.83,1.33-.96,2.81-.98,4.25-.11,7.4-.75,14.77-.94,22.17-.08,2.99-.34,5.98-.33,8.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.77,259.16c-3.34-.96-6.79-1.24-10.2-1.77-8.43-1.31-16.9-2.38-25.34-3.71-.84-.13-1.3.26-1.02.88.86,1.87-.42,3.65-.06,5.48.09.45.01.94.01,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.57,299.28c.39,3.51.22,7.04.11,10.56-.05,1.57-.22,3.2-.21,4.75.03,3.94-.53,7.85-.43,11.79.07,3.05-.16,6.1-.34,9.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.96,64.73c-2.41,2.09-3.01,5.03-3.69,7.92-.88,3.76-.88,7.6-1.12,11.43-.47,7.58.37,15.14.06,22.7-.03.71-.08,1.42.17,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.67,135.11c.01,6.92-.07,13.85-.36,20.76-.19,4.46-.36,8.91-.34,13.37,0,.59-.11,1.2.17,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.96,224.5c-.14,6.99-.62,13.96-.96,20.94-.18,3.63-.22,7.29-.59,10.92-.14,1.37-.76,2.51-1.51,3.47-.68.88-.86,1.71-.81,2.69.31,6.93-.16,13.85-.51,20.76-.16,3.1.03,6.22-.2,9.32-.12,1.69-.42,3.24-1.33,4.79-1.04,1.77-2.49,2.08-4.11,1.83-1.18-.18-1.16.24-1.27,1.11-.34,2.69-.29,5.41-.42,8.1-.19,4.1-.39,8.21-.51,12.31-.13,4.52-.27,9.03-.28,13.55,0,1.49-1.38,2.17-1.96,3.33-.43.86-.84,1.64-.88,2.65-.09,2.19-.59,4.34-.84,6.51-.12,1.02.13,1.62,1.39,1.81,1.65.25,3.32.41,4.96.92,1.42.44,3.03-.19,4.54-.35,2.17-.23,4.34-.43,6.52-.62,1.06-.09,2.18.2,3.16-.37.9-.53,1.51.35,2.29.38,2.53.08,5.05.54,7.55.82,2.43.27,4.71-.17,7.05-.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.5,99.57c-.17.27-.58.36-.53.79.48,4.08-.22,8.15-.2,12.23.01,4.81-.34,9.62-.53,14.43-.06,1.6.23,3.17.8,4.55.8,1.93.3,3.78.26,5.66-.07,3.7-.44,7.38-.51,11.09-.11,6.22-.87,12.42-.7,18.65.04,1.36.02,2.68.84,3.9.22.33.27.98.26,1.55-.2,7.39-.6,14.78-.81,22.17-.11,3.7-.28,7.38-.15,11.09.05,1.46.98,2.62.93,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.96,172.41c.28.56.16,1.17.17,1.76.14,6.98-.21,13.96-.2,20.94,0,3.52-.63,7.02-.5,10.56.04,1.15-1.03,1.7-1.45,2.62-.27.59-.76,1.06-.66,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.44,72.82c1.02-.06,1.12.79,1.21,1.41.58,3.91.51,7.86.31,11.78-.11,2.23-.14,4.47-.22,6.69-.17,4.63-.17,9.27-.58,13.9-.03.34.27.59.43.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.97,130.01c2.27.03,4.42.78,6.28,1.85,1.66.95,1.59,3.05,1.44,4.84-.51,6.15-.27,12.33-.61,18.47-.27,4.96.04,9.93-.42,14.87-.09,1,.69,1.76.93,2.71.32,1.27.18,2.47.13,3.71-.11,2.75-.15,5.52-.14,8.27.03,6.75-.66,13.48-.4,20.24.03.76-.04,1.49-.53,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.64,357.87c-2.65-.74-5.39-.62-8.1-.87-4.74-.43-9.5-.71-14.26-.99-3.1-.18-6.19-.55-9.32-.53-1.88.01-3.9-.56-5.61-1.52-1.29-.73-2.62-.67-3.88-.46-5.37.89-10.81,1.32-16.19,2.12-4.98.74-10.02,1.08-14.97,2.05-.62.12-1.29.02-1.93.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.82,81.97c-.82,1.24-.78,2.67-.86,4.05-.61,10.02-.41,20.06-.89,30.09-.01.27.18.49.35.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.5,258.28c-1.57,1.76-2.03,3.79-2.18,6.15-.39,6.22-.2,12.46-.98,18.66-.04.29-.02.59,0,.88.25,3.59-.58,7.15-.34,10.73.04.69-.26,1.14-.71,1.59-.76.77-1.39,1.62-1.24,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.51,334.3c.74-2.2.42-4.47.3-6.68-.2-3.64-.25-7.28-.45-10.91-.25-4.42-.41-8.85-2.66-12.84-.18-.33-.21-.79-.74-.91-.85.39-.91,1.51-1.71,1.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.84,169.95c.39,1.41-.71,1.83-1.57,2.48-.71.54-1.56.93-2.32,1.14-1.42.39-1.41,1.26-1.4,2.36.11,7.76-.58,15.49-.98,23.23-.15,2.92-.68,5.85-.24,8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.86,285.91c.84,1.55,1.6,3.13,1.76,4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.23,294.7c.64,3.79,1.11,7.59,1.14,11.44,0,1.2.07,2.35.88,3.35.57.7.65,1.61.69,2.46.07,1.7.17,3.41.15,5.1-.02,2.17.14,4.17,1.99,5.62.38.3.35.66.35,1.06.08,6.23.58,12.43.91,18.65.11,2.05-.03,4.14.49,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.03,263.56c2.83.36,5.62,1.01,8.44,1.42,4.99.72,9.97,1.61,14.97,2.19,2.56.3,5.01,1.1,7.56,1.28,1,.07,1.08.52,1.06,1.27-.02.59.04,1.18-.01,1.76-.1.94-.41,1.33-1.58,1.11-2.2-.41-4.45-.64-6.67-.95-3.52-.49-7.05-.96-10.56-1.56-3.05-.53-6.09-1.09-9.15-1.58-1.52-.24-3.04-.5-4.57-.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.26,287.84c-1.42-.25-1.96.33-1.78,1.76.07.58.37,1.37-.85,1.45-1.09.07-1.31-.61-1.56-1.29-.15-.41-.07-.93-.02-1.4.17-1.62-1.18-1.22-1.95-1.37-1.12-.21-.83.75-.87,1.37-.03.41-.03.82,0,1.23.04.65-.02,1.11-.89,1.08-.76-.03-1.23-.16-1.25-1.07-.02-.76-.03-1.51-.24-2.31-.32-1.18-.95-1.27-1.85-1.2-1.18.09-.59,1.01-.69,1.58-.08.46,0,.94-.02,1.4-.03.46.24,1.18-.52,1.2-.56.01-1.3-.26-1.2-1.02.11-.84-.53-1.48-.39-2.29.18-1.1-.5-1.22-1.4-1.26-1.02-.04-1.13.45-1.07,1.26.05.58-.02,1.17.02,1.76.04.56-.2.98-.72,1.03-.54.06-.99-.35-1.02-.86-.06-.78-.52-1.45-.41-2.29.14-1.11-.47-1.6-1.55-1.22-1.39.49-1.85-.21-2.14-1.41-.17-.67-.06-1.52-.83-1.98-.04-.02-.29-.46-.18-.66,1.45-2.7.17-5.96,1.75-8.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.7,80.91c-.81.64-.88,1.56-.87,2.46.03,2.94-.24,5.86-.2,8.8.06,5.57.01,11.14.02,16.72,0,1.7-.47,3.4,0,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.54,316.88c-3.16,1.3-4.22,4.22-5.24,7.05-1.07,2.98-.94,6.19-1.3,9.31-.31,2.64.03,5.29-.3,7.92-.34,2.68-.19,5.39-.2,8.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.63,296.64c.47.07.92.19,1.41.19.76,0,1.06-.23,1.08-1.07.12-4.76-.3-9.5-.36-14.25,0-.54-.15-.83-.71-.88-2.52-.24-5.05-.2-7.57-.51-1.03-.13-1.1.68-1.04,1.39.37,4.63.94,9.25.67,13.9-.05.88.61,1.21,1.07,1.18,1.77-.1,3.52.42,5.28.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.89,154.64c.96.79.59,1.9.48,2.81-.28,2.35-.26,4.71-.24,7.04.04,5.64-.6,11.26-.42,16.89.08,2.65-.26,5.21-1.58,7.57-.74,1.33-1.94,1.73-3.35,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.99,74.05c-2.31,1.56-2.65,4.12-3.34,6.51-.12.4-.01.98.2,1.11,2.41,1.55,1.28,3.95,1.3,5.93.01,2.03-.11,4.11-.2,6.16-.13,2.93-.33,5.86-.24,8.8.1,3.58-.27,7.15-.18,10.73.02.68.01,1.33.37,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.84,221.42c-2.67-.36-4.4,1.11-4.78,3.78-.4,2.87-.24,5.76-.4,8.63-.35,6.03-.72,12.07-.83,18.12-.03,1.76-.39,3.5-.36,5.28.02,1.01.66,1.34,1.23.99.7-.42,1.33-.15,1.97-.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.87,147.96c-.18.12-.24.24-.17.35,1.29,2.18.64,4.55.71,6.86.25,8.82-.79,17.59-.95,26.39-.02,1.08.11,1.35,1.11,1.43,1.46.11,2.84.58,4.22,1.04,1.09.36,1.74,1.24,1.73,2.28-.06,5.81.05,11.61-.23,17.42-.21,4.44-.47,8.91-.33,13.37.01.42,0,.79.25,1.04,1.19,1.2,1.22,2.68,1.24,4.23.06,5.75-.13,11.5-.25,17.24-.1,4.81,0,9.62-.11,14.43-.01.59.05,1.49-.68,1.31-.47-.12-1.69.17-1.59-.96.28-3.08-1.83-3.43-4.06-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.88,242.09c.12,2.58-.31,5.19.36,7.74.07.28.07.7.52.7s.51-.43.51-.7c.03-2.11.11-4.23-.05-6.33-.04-.56-.18-1.41-1.32-1.68-1.3-.3-1.32.76-1.55,1.17-2.41,4.38-4.09,8.95-4.81,14.02-.36,2.57-.72,5.17-1.07,7.77-.15,1.09-.21,2.08.13,3.19.28.91-.1,1.99-.08,2.97.12,4.88-.13,9.75-.48,14.6-.3,4.11.05,8.23-.43,12.32-.04.35-.09.73,0,1.05.41,1.29.05,2.16-1.24,2.66-.22.08-.32.41-.36.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.38,152c-.42,2.86-.25,5.76-.29,8.62-.08,6.4-.43,12.78-.47,19.18,0,1.39.1,2.84-.3,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.65,318.81c-2.46-.34-3.2,1.67-4.2,3.18-1.46,2.21-1.92,4.81-2.1,7.38-.37,5.33-.66,10.66-.76,16.01-.02,1.24.21,2.46.19,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.64,322.15c2.51.45,5.05.13,7.57.15,9.27.07,18.53.03,27.8.03.71,0,1.42.04,2.11-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.6,190.19c.56.82.46,1.78.32,2.63-.56,3.45-.13,6.93-.34,10.39-.33,5.45-.34,10.91-.63,16.37-.07,1.22-1.08,1.8-1.27,2.81-.47,2.54-2.64,2.36-4.41,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.1,338.52c.2,0,.4-.14.53-.15.9-.04,2.03.12,2.57-.44.63-.65.24-1.81.23-2.75-.1-6.75-.32-13.49-.52-20.24-.04-1.31-.35-2.56-1.05-3.7-.34-.55-.86-.57-1.41-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.66,87.78c1.08-1.27,2.53-2.06,3.9-3.01.95.53.49,1.44.47,2.13-.17,4.52-.26,9.03-.34,13.55-.15,9.1-.89,18.17-.88,27.27,0,.85-.15,1.68-.86,2.3-.25.22-.47.44-.57.86-.49,2.19-1.22,2.75-3.67,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M191.69,279.92c-1.14.83-1.39,2.06-1.4,3.34-.03,3.17.04,6.34-.04,9.5-.03,1.28.53,1.44,1.61,1.44s1.64-.16,1.61-1.44c-.08-3.05.04-6.1-.06-9.15-.04-1.33-.25-2.72-1.38-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.38,298.4c.3,3.05.15,6.1.16,9.15,0,.76.15,1.37.7,1.95,1.21,1.27,1.38,2.89,1.43,4.56.21,7.39.32,14.79.7,22.17.18,3.58.63,7.15.67,10.73,0,.79.41,1.27.9,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.18,216.23c.43-.96.3-2.03.29-2.99,0-5.46.32-10.91.25-16.36-.01-1.14-.71-1.5-1.6-1.76-1.44-.41-2.94-.56-4.4-.86-.47-.1-1.23-.32-1.23.68,0,1.76.3,3.53-.17,5.28.35.07,0,.95.7.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.05,183.15c.01.47-.13,1.01.19,1.4,1.44,1.74.73,3.74.65,5.64-.03.7-.15,1.41-.12,2.11.2,4.06-.27,8.1-.48,12.14-.14,2.74-.07,5.53-.54,8.28-.36,2.11.12,4.19,1.11,6.18.31.62.63.98,1.12.99,1.88.05,3.73.91,5.62.34.44-.13.94-.12,1.03.06.59,1.14,1.71,2.07,1.61,3.5-.19,2.99.13,6.02-.1,8.97-.38,4.82-.05,9.63-.24,14.44-.05,1.17,0,2.35,0,3.52q-.01,1.86-1.93,1.59c-.17-.02-.35,0-.53,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.41,306.49c-1.81-.3-1.98,1.23-2.42,2.31-.17.43-.23,1.03-.23,1.56-.02,7.21.02,14.43-.01,21.64,0,.82.28,1,1.06,1.12.54.08,1.07.02,1.59.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.3,187.55c-1.81.07-2.91.93-3.76,2.6-.79,1.53-.78,3.04-.81,4.61-.02,1.47-.07,2.94,0,4.4.21,3.94-.2,7.88-.49,11.78-.22,2.93.29,5.92-.55,8.81-.18.63-.05,1.33.33,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.14,273.06c1.7-1.04,3.45-.06,5.09.11,2.28.23,4.6.51,6.88.93,3.33.62,6.67,1.13,10.02,1.61,1.35.2,2.71.23,4.05.5.39.08.75.03,1.07-.33.35-.4.76-1.13,1.36-.51.39.41,1.05.9.59,1.74-.18.33-.01.81-.17,1.23-.06.15.03.53.32.7,1.74,1.01,1.97,2.57.52,3.86-.6.53-.46,1.24-.31,1.76.73,2.54,1.67,5,2.76,7.41,2.73,6.02,5.5,12.02,8.42,17.96.54,1.1,1.39,2.03,1.66,3.31.5,2.34,1.38,4.62,1.34,7.05-.02,1.24.09,2.4,1.1,3.14.94.69.86,1.56.86,2.49,0,3-.05,5.99.33,8.98.13,1.01.62,1.8,1.28,2.44.89.87,1.13,1.83,1.05,3.02-.11,1.52.05,3.07.24,4.56.17,1.3.97,2.49,1.2,3.87.25,1.47-.06,2.95.41,4.43.26.81-.21,1.74-1.52,1.58-.97-.12-2.04-.21-2.45,1.04-.23.68-.88.4-1.25.47-2.31.47-4.69.06-7.03.39-.99.14-1.63-.82-2.64-.9-2.29-.18-4.46.52-6.68.79-1.06.13-2.12.11-3.18.25-2.08.27-3.97,1.35-6.16,1.16-1.15-.1-1.04,1.05-1.05,1.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.52,250.89c-.91,1.09-.6,2.46-.86,3.7-.33,1.56-.27,3.18-.67,4.76-.23.88.04,1.89.15,2.82.19,1.56,1.04,3.27-.13,4.95-.41.59-.07,1.71-.06,2.59,0,.61-.05,1.18-.88,1.05-.6-.1-1.33-.08-1.24-1.05.04-.47.03-.94,0-1.41-.04-.68.3-1.52-.53-1.92-1.05-.51-2.21-.4-3.33-.33-.26.02-.5.37-.39.85.13.55.05,1.17.02,1.75-.04.72.38,1.72-1.05,1.6-1.1-.09-2.17.01-2.13-1.6.02-.88-.5-1.71-.35-2.64.09-.57-.28-.9-.86-.87-.38.02-.68-.19-1.06-.21-2.64-.13-2.59-.15-2.68,2.48-.02.58.66,1.61-.67,1.76-1.64.19-2.18-.14-2.46-1.59-.08-.42-.33-.78-.38-1.23-.07-.71.45-1.84-.35-2.03-1-.24-2.05-.58-3.15-.46-.66.07-.72.39-.71.9.02.64.01,1.29,0,1.94-.01.86.25,1.91-1.23,1.76-1.09-.11-2.08-.3-1.94-1.76.04-.41,0-.82,0-1.23-.01-2.09-.25-2.35-2.29-2.46q-2.68-.15-2.64,2.64c.03,1.92-.08,1.99-1.94,1.59-1.08-.24-2.24-.23-1.96-1.95.59-3.62-2.04-4.18-4.73-3.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.12,323.74c-6.22,0-12.43.01-18.65,0-2.65,0-5.26.55-7.92.39-.92-.06-1.92-.65-2.81.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.55,315.64c-1.12.35-1.41-.57-1.74-1.24-3.09-6.25-6.22-12.49-9.17-18.82-.2-.43-.38-.86-.68-1.25-.83-1.04-1.13-1.05-1.77.19-2.77,5.36-5.73,10.62-8.44,16.01-1.6,3.19-3.57,6.18-4.96,9.49-.52,1.23-1.84,1.51-2.94,1.18-1.03-.31-2.01-.2-3.01-.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.87,217.46c-.84-2.56-.03-5.16-.11-7.74-.03-1.15.07-2.35.09-3.52,0-.85-.05-1.97.42-2.41,1.95-1.79,1.09-3.99,1.16-6.04.03-.8-.15-1.61-1.22-.71-.07.06-.24-.03-.34.01q-4.2,1.84-4.22,6.51c-.01,4.28-.04,8.56.03,12.84.01.94-.5,1.88-.03,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.76,354.18c-1.68-.42-3.41-.29-5.11-.45-5.85-.57-11.72-1-17.59-1.44-2.06-.15-4.1-.42-6.16-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.03,36.75c.18-.57.37-1.13.36-1.76-.02-3.99,0-7.98-.02-11.97,0-1.05-1.11-2.07-2.11-1.93-.87.12-.72.83-.7,1.4.09,3.17-.82,6.32-.2,9.51.03.15-.38.24-.33.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.1,33.05c1.48-.43,2.39-.1,2.87,1.57.37,1.28,1.36,2.06,2.73,2.72,8.17,3.95,16.57,7.43,24.68,11.52,1.05.53,2.3.68,3.16,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.08,349.96c1.93.74,3.99.54,5.99.66,6.57.4,13.14.77,19.7,1.28.9.07,1.75-.21,2.64-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.52,123.32c.54,3.52-.12,7.04-.06,10.56.01.73-.1,1.53-.1,2.29,0,4.81,0,9.62-.36,14.43-.15,2.03-2.48,4.41-4.41,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.3,321.45c-2.33,1.4-2.72,3.9-3.11,6.17-1.09,6.45-1.12,12.99-1.12,19.52,0,.65.04,1.29.54,1.75.28.26.56.67.48.88-.79,2.21,1.01,2.16,2.15,2.25,2.01.16,3.85,1.12,5.99.82,2.63-.37,5.29-.76,7.89-1.22,3.9-.69,7.63-.91,11.47.23,1.87.56,3.73,1.42,5.79,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.94,289.6c-1.04.13-1.74.43-2.35,1.55-3.91,7.23-7.7,14.52-11.7,21.69-.83,1.48-1.74,2.44-3.55,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.87,107.31c.4,2.28.3,4.59.13,6.86-.41,5.46-.17,10.91-.34,16.37-.16,5.1-.23,10.21-.49,15.31-.06,1.11-.08,1.96,1.58,2.02,1.16.04,2.34.77,3.53,1.12.37.11.77.26.85.55.57,2.12,2.97,3.02,3.43,5.26.09.46.29.92.29,1.42,0,5.28,0,10.56,0,15.84,0,5.57.06,11.15-.03,16.72-.04,2.17-.13,4.34-.15,6.51,0,.68.04,1.33.36,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.75,297.7c-.21,4.81.07,9.63.25,14.43.13,3.4.29,6.8.26,10.21,0,.98.52,1.36,1.24,1.19.84-.2,1.66-.03,2.47-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.66,287.67c-3.7-1.37-7.29-3.01-10.91-4.58-5.05-2.2-10.02-4.6-14.95-7.05-.39-.19-.72-.07-1.07-.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.47,307.73c-.71.43-.52,1.13-.52,1.76,0,3.64.13,7.28-.04,10.91-.22,4.87-.56,9.76-.37,14.6.13,3.43-.15,6.81-.11,10.21,0,.89-.22,1.75-.19,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.18,300.51c1,1.43,1.22,3.09,1.4,4.75.37,3.45.32,6.91.23,10.38-.16,6.39-.07,12.79-.02,19.18,0,1.13-.16,1.31-1.43,1.31-4.06,0-8.08-.67-12.14-.44-.63.04-1.33.19-1.76-.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.61,327.96c.81.89.5,1.98.52,2.99.1,7.39.74,14.77.77,22.17,0,1.33.19,2.71.48,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.17,296.46c0-3.34,0-6.69,0-10.03,0-1.17.05-2.33,1.06-3.17,1.07.87,1.24,2.1,1.22,3.34-.04,3.29.28,6.57.19,9.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.49,276.93c-.16.25-.55.33-.53.7.11,2.08-.47,4.09-.58,6.16-.04.85.77,1.39.55,2.11-1.04,3.4.49,6.8-.08,10.22-.14.82.07,1.87.23,2.81.19,1.08.25,2.21.24,3.34-.01,4.58.41,9.14.41,13.72,0,1.8.22,3.63.29,5.45.04,1.02.59,1.96,1.26,2.6.83.79.72,1.53.71,2.51-.03,3.23.13,6.46.35,9.67.15,2.18-.02,4.35.15,6.51.1,1.28.61,2.49,1.04,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.29,253c-1.83-.89-3.87-.93-5.81-1.18-5.99-.78-12-1.4-17.94-2.51-.76-.14-1.53-.2-2.29-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.39,293.65c1.09,1.65.78,3.52.66,5.28-.16,2.27.46,4.45.47,6.69,0,.89.14,2.13,1.5,2.51.38.11.62.76.55,1.36-.26,2.34.42,4.68.02,7.04-.23,1.37-.03,2.73,1.2,3.69.13.1.24.23.35.35,1.86,1.92,2.43,4.17,2.35,6.86-.15,5.05.65,10.07.66,15.13,0,1.03.48,1.99.67,2.99.23,1.26-.35,1.88-1.56,1.55-1.83-.5-3.63-.42-5.46-.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M358.32,308.08c-.77,2.13-.44,4.36-.29,6.51.33,4.81.73,9.62,1.01,14.43.27,4.63.12,9.28.67,13.9.14,1.16.04,2.34.02,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.12,330.6c.38.97.3,2.02.3,2.99,0,6.69.23,13.37.39,20.06.02.9.08,1.78.36,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.73,84.61c1.39.57,2.69,1.36,4.22,1.6,1.22.19,1.69,1.03,1.6,2.27-.32,4.39-.48,8.81-.61,13.2-.18,5.98-.72,11.95-.46,17.94.15,3.52-.23,7.04-.17,10.56,0,.44.07.91-.35,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.14,329.02c-.87.54-.83-.14-1.08-.69-.64-1.42-.36-2.95-.61-4.42-.94-5.56-3.29-10.38-6.95-14.58-1.7-1.94-2.37-1.93-4.02,0-3.08,3.61-5.53,7.58-6.52,12.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.96,321.8c.45,1.74.22,3.43-.35,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.96,299.1c.37,2.8,0,5.65.53,8.45.09.48-.09.94.33,1.43,1.02,1.19,1.18,2.68,1.08,4.2-.13,2,.28,3.98.17,5.98-.02.33.03.67.2.87,1.9,2.16,1.65,4.88,1.69,7.4.09,6.06.85,12.07.94,18.12.02,1.03.46,1.92,1.22,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.05,330.42c1.18,3.45.56,7.04.84,10.56.38,4.85.21,9.73.22,14.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.09,325.15c0,7.74,0,15.48,0,23.23,0,.66.2,1.37-.34,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.41,59.8c-.4,1.08-.27,2.25-.3,3.34-.21,6.74-.42,13.49-.58,20.23-.01.47-.07.96.17,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.65,316.52c-.27-.04-.54-.15-.7-.36-1.96-2.5-2.44-2.16-4.7-.28-2.7,2.24-3.82,5.6-4.81,8.91-.83,2.77-.71,5.61-.71,8.45,0,1.78-.16,1.88-1.93,1.59-2.27-.38-4.59.02-6.86-.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.38,111.88c2.07,1.33,1.97,3.3,1.6,5.37-.09.49-.2.97-.21,1.49-.07,10.26-.52,20.53-.33,30.79.02.79-.08,1.55-.36,2.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.15,62.44c.45,1.76-.02,3.52-.04,5.28-.1,5.87-.56,11.72-.48,17.6,0,.59-.05,1.19.18,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.38,325.15c.57,5.68.69,11.36.4,17.07-.07,1.32.19,2.7.11,4.04-.09,1.57.28,3.1-.91,4.67-.73.96-.53,2.84-.12,4.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.84,302.62c2.53,1.96,3.21,4.8,3.7,7.74.6,3.61.7,7.27.83,10.91.18,4.81.31,9.62.56,14.43.1,1.89.01,1.89-1.92,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.66,274.47c-.3,1.72,1.01,2.99,1.27,4.57.25,1.54.58,3.07.98,4.59.18.66.06,1.4-.27,2.12-.31.67-.69,1.52.64,1.98.81.28.53,1.42.55,2.22.02.63-.23,1.38.88,1.42,1.24.05.8-.82.88-1.42.02-.17.07-.39,0-.52-.34-.6-.15-1.3.37-1.35.74-.07,1.55.23,1.41,1.35-.06.52-.06,1.06,0,1.58.05.34.22.67.68.72.58.06.69-.27.7-.71.01-.53.04-1.06,0-1.58-.05-.68.21-.9.89-.9s.9.22.9.9c0,.64-.23,1.33.17,1.93.21.31.28.81.87.72.57-.09.37-.59.55-.87.28-.43.1-.84.14-1.25.05-.5-.13-1.08.71-1.06.73.02,1.13.28,1.06,1.06-.01.12,0,.23,0,.35,0,1.7.3,3.47-.08,5.08-.44,1.87.82,3.26.79,4.95-.03,1.7-.16,3.42.04,5.1.2,1.65.31,3.28.31,4.93,0,1.7-.1,3.41.03,5.1.14,1.82.32,3.63.34,5.46.03,1.93,2.95,4.98,4.56,4.94.75-.02,1.14-.09,1.29-1.06.21-1.31.35-2.56.14-3.89-.1-.63-.08-1.29.29-1.95.4-.72.71-1.56.56-2.44-.18-1.13.35-1.72,1.41-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.83,315.64c-2.37,0-2.35,0-2.48-2.46-.02-.47.18-.95-.32-1.43-2.48-2.39-3.52-5.31-3.41-8.78.07-2.21-1.33-4.07-2.87-5.34-.88-.72-2.73-.85-4.11-.42-.84.26-.84,1.24-.91,2.06-.2,2.48.35,4.92.37,7.39.05,4.81-.24,9.63.35,14.43.11.91-.19,1.63-.98,1.94.28.81.75.68,1.16.7,1.82.09,3.64-.15,5.46.15.91.15.93.06.35,1.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.84,291.89c-6.5-3.26-13.18-6.14-19.71-9.32-.92-.45-1.87-.91-2.83-1.19-1.21-.35-1.76-1.09-2.1-2.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.22,302.27c-2.11-.02-4.22.33-6.33.17-1.24-.1-1.43.53-1.43,1.59.04,5.87.02,11.73.02,17.6,0,6.45,0,12.9,0,19.36,0,3.91.24,7.83-1.18,11.63-.44,1.17.25,2.61-.4,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.08,252.47c.92.74.89,1.78.88,2.82,0,.86.28,1.28,1.2,1.66,1.25.5,1.6.18,1.8-.95.09-.52-.46-1.44.87-1.26,2,.27,2.53.63,2.47,1.96-.07,1.34-.19,2.67,1.57,3.2.71.22.98.14,1.06-.56.01-.12-.02-.24,0-.35.15-.83-.49-2.04.55-2.39.9-.3,1.99.21,2.96.49.55.16.73.77.72,1.38-.02.7.01,1.41,0,2.11-.05,1.65,1.32,1.57,2.3,1.72,1.28.2.85-.93.85-1.54-.01-1.29.26-1.92,1.62-1.07.13.08.36-.03.52.02,2.37.76,2.39.76,2.45,3.34.02.89.15,1.47,1.24,1.63.77.11,1.18.2,1.26-.75.06-.71-.45-1.8.36-2.03.83-.24,1.88-.46,2.8.08.14.08.4-.02.52.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.48,313c1.18-.13,1.56.5,1.59,1.58.2,6.1.55,12.2.68,18.3.02.82.81,2.16-1.04,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.94,310.54c4.35,3.71,6.52,8.6,7.56,14.08.72,3.78.84,7.61,1.05,11.44.06,1.02.1,2.01-.48,3.01-.63,1.1-.39,2.43-.39,3.67,0,4.4,0,8.8,0,13.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.57,313c-1.48-.14-1.55.86-1.59,1.94-.09,2.59.04,5.17.21,7.74.23,3.46.1,6.93.47,10.39.1.91.06,1.58,1.27,1.42.77-.1,1.09.63,1.58,1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.44,297.08c-1.8-.81-3.63-.03-5.36.18-4.1.5-8.22.87-12.33,1.32-1.64.18-3.26.45-4.93.37-1.01-.05-1.25.79-1.6,1.56-1.58,3.4-3.12,6.83-5.08,10.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.17,64.73c.46,6.74.28,13.5.23,20.23-.04,6.38.07,12.8-.55,19.18-.13,1.32-.63,3.12.24,3.95,1.23,1.18,2.37-.89,3.76-1.1.82-.12,1.54-.47,2.3-.03,1.23.72,2.84.61,3.88,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.22,83.73c.28.56.15,1.17.17,1.76.22,6.46-.33,12.9-.35,19.36,0,.59-.11,1.2.17,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.62,100.45c-1.05-.05-1.58.91-2.44,1.29-2.12.93-3.55-.72-5.3-1.11-.91-.2-1.69-.8-2.64-.87-1.91-.14-3.06,1.39-4.57,2.11-.22.11-.18.33-.18.53.03,2.29-.47,4.54-.25,6.87.21,2.2-.13,4.46-.32,6.68-.2,2.35-.12,4.7-.25,7.05-.13,2.22-.29,4.45-.23,6.68.02.6-.16,1.25.35,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.34,267.43c-4.56-.71-9.13-1.33-13.72-1.8-2.93-.3-5.83-1.03-8.8-1.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.42,216.05c.53-4.33.28-8.68.37-13.02.03-1.39-.19-2.75-.58-4.04-.9-2.99-1.62-3.6-4.19-1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.87,120.33c1.39.34,2.68,1.05,4.06,1.35,1.1.23,1.24.76,1.23,1.64-.02,1.82,0,3.64,0,5.45,0,5.28.01,10.56,0,15.84,0,1.48-.11,2.96-.52,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.11,52.23c6.17,2.86,12.2,6.01,18.48,8.61,1.22.51,2.39,1.2,3.45,1.87,1.39.88,2.7.75,4.11.78.86.02,2-.3,2.08,1.05.07,1.12-.81,1.97-1.73,2.03-1.1.07-1.63.69-2.28,1.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.7,85.14c.12,0,.28.05.35,0,2.46-2.07,5.01-2.11,7.78-.58.56.31.9.3.5.93-.46.71-.33,1.51-.35,2.29-.22,6.27-.17,12.55-.17,18.83,0,.37-.05.72-.18,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.34,79.51c.01,2.82.1,5.64-.19,8.44-.22,2.17-.26,4.34-.31,6.51-.22,8.39-.49,16.78-.91,25.16-.07,1.45-.08,2.55,1.92,2.92,1.49.27,3.37.44,4.24,2.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.24,211.12c-1.52.08-3.03-.35-4.37-.8-2.58-.86-5-.68-7.22.51-2.53,1.35-5.03,1.18-7.59.62-2.45-.53-4.91-.92-7.39-1.25-1.96-.26-3.42,1.22-5.29,1.15-.51-.02-.33.75-.35,1.18-.05,1.65.19,3.28.17,4.93,0,.67.12,1.23-.86,1.63-6.58,2.71-13.28,5.11-19.91,7.69-.61.24-1.24.61-1.93.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.01,264.62c1.04,1.17.9,2.74.98,4.05.3,5.45,1.19,10.87.97,16.36-.08,1.94-.05,3.84-1.93,5.13-.51.35-.15,1.14-.18,1.73-.03.51-.05.89-.72.89s-.73-.38-.71-.89c.02-.47,0-.94,0-1.41.03-.74-.37-1.16-1.06-1.22-.99-.08-.63.71-.7,1.22-.09.61.29,1.67-.53,1.68-1.08.02-.87-1.09-.88-1.86,0-.74.18-1.6-1.06-1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.98,263.03c-3.83-.83-7.75-1.09-11.62-1.74-2.46-.41-4.94-.75-7.39-1.25-.87-.18-1.75-.19-2.64-.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.69,42.2c.45-2.92-.07-5.87.33-8.8.17-1.2-.84-1.6-1.74-1.73-1.35-.19-.86.95-.85,1.55.02,2.65-.62,5.26-.38,7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.41,303.68c.41.31.44.85.66,1.26.35.67.79,1.51,1.43,1.3.71-.23,1.11-1.12,1.09-2.03-.01-.53-.16-1.09.25-1.73,1.45.9,1.66,2.51,1.97,3.85,1.16,4.9,1.38,9.93,1.45,14.94.05,4.11.13,8.21.37,12.32.02.34-.15.52-.36.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.15,257.93c-.42.45-.72.89-.72,1.58,0,2.64-1.1,5.29.16,7.94.25.53.06,1.27.03,1.92-.03.51.3,1.24-.69,1.24-.88,0-.85-.74-.85-1.24,0-.87-.08-1.51-1.08-1.78-1.03-.27-1.84-.47-1.79,1.08.02.49.03,1.28-.85,1.22-.77-.05-.64-.68-.72-1.22-.34-2.16-.73-2.36-2.45-1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.23,262.33c.12,6.81-.12,13.61-.25,20.41-.07,3.75.19,7.52-.28,11.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.21,312.12c-.2,1.88-.21,3.75-.02,5.63.12,1.19.1,2.39-.49,3.52-.58,1.12-.23,2.32-.23,3.51,0,5.58.34,11.15.56,16.72.03.9.16,1.77.36,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.1,200.39c-1.96-1.27-1.94-1.27-2.65,1.05-.46,1.5-.65,3.01-.71,4.58-.14,3.52.43,7.06-.33,10.56-.12.57.37,1.02.35,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.87,54.35c-2.32,2.3-5.07,4.08-7.58,6.14-1.45,1.19-2.91,2.38-4.36,3.57-2.15,1.76-4.4,2.78-7.24,2.11-.7-.17-1.48.01-1.74.86-.26.86.59.89,1.03,1.24.18.15.48.22.54.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.7,51.18c1.66,1,2.68,2.76,4.38,3.72.41.23,1.1.63.55,1.38-.57.77-.94,2.39-1.89,2-1.43-.58-1.5.51-1.57,1-.15,1.09-1.23,1.76-1.62,1.65-1.67-.46-1.83.87-2.28,1.7-.39.73-.79,1.1-1.62,1.04-1.48-.1-1.23,1.53-2.07,2.16-.84.64-2.6-.14-2.59,1.18.02,1.68-2.06,2.12-1.73,3.88.25,1.3.06,2.69.05,4.04-.03,3.99-.39,7.98-.52,11.97-.01.36-.17.62-.36.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.93,323.91c-.29,5.04-.22,10.09-.04,15.13.06,1.69.57,3.4.04,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.43,296.46c-4.94-.28-9.84-.93-14.78-1.3-1.76-.13-3.52-.26-5.28-.27-.47,0-.69-.39-1.06-.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.56,132.47c1.02-2.44-.43-8.11-2.64-9.49-1.99-1.25-3.8-1.46-6.48.9-2.52,2.22-3.74,5.3-4.54,8.44-.75,2.91-1.23,5.9-.77,8.96.24,1.61.58,3.27,1.48,4.54,2.16,3.06,5.64,2.92,8.38-.33,3.12-3.69,4.23-8.17,4.76-12.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.68,39.56c.51,3.47-.05,6.92-.12,10.38-.07,3.98-.59,7.98-.06,11.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.83,72.82c.06-2.67,4.28-7.11,7.22-7.72,1.01-.21,1.99-.06,2.83.83,3.44,3.66,6.04,7.69,6.55,12.86.09.87.36,1.76.28,2.64-.11,1.14.85,1.37,1.43,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.26,282.56c-3.03-1.28-6.14-2.37-9.34-3.12-2.05-.48-4.21-.63-6.32-.71-1.25-.05-2.43-.63-3.69-.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.72,74.05c-.72-.28-.87-1.07-1.09-1.61-.42-1.08-1.21-1.79-2.02-2.41-1.85-1.44-3.67-1.14-4.7.86-1.94,3.76-3.3,7.71-3.98,11.94-.25,1.53.44,3.79-2.03,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.08,282.74c4.13.73,8.33.86,12.48,1.33,1.57.18,3.23-.1,4.78.56.53.23,1.29.16,1.92-.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.86,219.22c.46,2.65-.11,5.28-.2,7.92-.12,3.28-.47,6.56-.32,9.85.02.52-.17.9-.53,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.2,53.82c0-2.58-.06-5.16.03-7.74.04-1.02-.43-1.51-1.26-1.55-1.08-.05-.83.87-.88,1.55-.17,2.28-.05,4.58-.35,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.41,258.63c.62,2.09-.72,3.94-.87,5.97-.08,1.09-.35,2.38-.08,3.32.35,1.21,0,2.4.39,3.56.19.57-.3,1.2-.84,1.16-.45-.03-1.24-.15-1.24-1,0-.5.04-.97-.33-1.42-.43-.52-.97-.4-1.42-.3-.41.09-.36.63-.36,1.02,0,.43.09.93-.53,1.06-.74.16-.72-.54-.84-.89-.13-.37-.1-.95-.26-1.18-.36-.52-1.05-.79-1.71-.72-.66.07-.77.62-.71,1.21.04.45.1.96-.52,1.05-.8.11-.72-.63-.85-1.05-.12-.37.1-.86-.05-1.21-.26-.62-.9-.29-1.38-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.71,281.16c.12-.12.33-.23.34-.35.03-.83.5-1.4,1.25-1.36.8.04,1.03.92,1.21,1.55.38,1.37.56,2.78.56,4.22,0,2.35,0,4.69,0,7.04,0,1.94,0,1.91-1.93,1.95-.69.01-1.31-.16-1.94-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.5,296.46c-1.62,1.43-3.57,2.43-4.96,4.2-2.51,3.2-3.95,6.79-4.53,10.76-.1.67-.01,1.36-.72,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.13,251.07c.98.82.67,2.07.62,2.99-.14,2.59.01,5.17-.1,7.75-.02.5.3,1.24-.7,1.24s-.63-.73-.7-1.24c-.18-1.28.39-2.64-.35-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.31,319.16c.26.3.38.65.36,1.06-.25,5.17.46,10.32.34,15.48-.02.69.37,1.65-.87,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.77,279.57c-4.15-.47-8.31-.87-12.49-1.09-1.76-.09-3.52-.32-5.28-.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.37,296.46c2.15,2.17,4.33,4.28,5.84,7.02,1.55,2.83,2.45,5.81,2.78,8.99.06.53-.19,1.2.71,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.27,279.92c.9,2.2,1.45,4.48,1.58,6.86.2,3.69-.41,7.41.35,11.09.02.11,0,.23,0,.35-.23,4.58.55,9.14.37,13.73-.13,3.28.17,6.57.16,9.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.75,291.89c1.03,1.64.46,3.43.28,5.1-.19,1.76-.55,3.63-.47,5.28.1,1.99.01,4,.11,5.99.23,4.92.04,9.85.1,14.78.02,1.36-.42,1.84-1.79,1.78-2.17-.09-4.34-.02-6.51-.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.37,200.39c.43-.31.36-.98,1.05-1.3,1.06,1.36,1.17,3.03,1.21,4.65.08,2.75.03,5.51.02,8.27,0,2.07-.38,2.31-2.46,1.59-.16-.05-.35,0-.53,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.09,281.68c.19-.39.32-.88-.19-1.02-.35-.1-.83-.21-1.23.13-.4.34-.1.66.02.88,1.61,2.84,1.17,5.94,1.21,8.98.03,1.7,0,3.4,0,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.94,296.46c0-3.23,0-6.45,0-9.68,0-1.06-.19-2.05-.68-3.01-.15-.3-.15-.68-.56-.68s-.38.5-.56.66c-.77.69.28,2.09-1.02,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.89,61.38c.03,2.88-.31,5.74-.17,8.62.02.51.02,1.2-.37,1.37-1.44.62-1.25,1.92-1.37,3.03-.43,3.86-.56,7.73-.54,11.61,0,.69-.15,1.43.53,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24,109.24c-.4-3.12.04-6.22.13-9.33.07-2.45.44-4.96-.3-7.39l.7-5.28c2.56-1.82,4.94.02,7.39.36.8.11.94.7.88,1.4-.66,8.49-.71,17-.92,25.51-.06,2.46-.06,4.93-.14,7.39-.02.6.16,1.25-.35,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.84,155.87c-.4,2.28-.07,4.58-.18,6.86-.06,1.34,1.18.98,1.78,1.16.92.28.66-.66.67-1.16.03-1.47,0-2.93.01-4.4q0-2.24-2.11-2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.73,280.98c-.58.35-.42.95-.33,1.4.23,1.12.19,2.24.13,3.35-.21,3.94.49,7.85.37,11.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.79,326.03c-.53,1.7-.07,3.42.04,5.1.29,4.46-.22,8.97.83,13.38.05.22-.04.48.01.7.51,1.99.64,2.06,2.81,1.76,2.03-.28,1.97-.22,2.14,1.76.16,1.82.01,3.69.67,5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.83,40.09c-.39-1.75-.08-3.52-.17-5.28-.04-.72.13-1.47-.52-2.11-.98.35-1.35,1.12-1.26,2.29.15,2.05-.5,4.1.02,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.2,295.06c0,4.81,0,9.62,0,14.43,0,.69.15,1.43-.53,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.89,276.41c.65,1.61-.51,2.84-.93,4.21-.19.62-.43,1.07.05,1.6,1.93,2.13,1.34,4.55.29,6.66-2.3,4.63-4.8,9.16-7.47,13.6-1.64,2.74-2.85,5.74-4.63,8.41-.34.52.08,1.13-.34,1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.66,280.8c1.28,1.2,1.41,2.85,1.54,4.4.22,2.57-.08,5.16.19,7.74.13,1.26-1.55,2.21-2.61,1.58-.42-.25-.36-.66-.35-1.06.07-2.99-.31-5.98-.18-8.97.06-1.26.25-2.48,1.06-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.7,314.06c-1-.18-1.3.25-1.25,1.23.17,3.52.37,7.03.42,10.56.06,3.46.33,6.92.3,10.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.76,312.21c-1.08.04-.94.85-.86,1.49.16,1.23.16,2.46.15,3.7,0,.68.33,1.02.86,1.44,1.33,1.03,2.16,2.28,2.01,4.2-.24,3.1.11,6.22.27,9.32.07,1.28.61,2.02,1.79,2.08,1.4.07,1.57.81,1.6,1.97.1,3.48.32,6.96,1.04,10.38.19.91-.46,1.24-1.07,1.36-.45.09-.91.31-1.4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.39,340.28c.85,1.39.37,2.96.45,4.4.18,3.51.39,7.03.27,10.55-.01.36-.17.62-.36.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.06,253.88c-.35-.35-.64-.87-1.07-1.03-2.21-.83-2.28-2.73-2.45-4.6-.04-.41.11-.88-.19-1.22-.45-.53-1.04-1.04-1.74-.85-.67.18-.69.91-.72,1.55-.06,1.25.31,2.56-.52,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.04,62.62c.66.38,1.59-.5,2.1.36.8,1.36,2.11,2.43,2.46,4.04.29,1.35-1.09,1.48-1.77,2.08-.63.57-1.11-.05-1.57-.5-.71-.7-1.22-1.57-2.1-2.13-.94-.6.19-1.75-.54-2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.69,321.45c.6,1.83.52,3.75.68,5.63.14,1.63.07,3.28.02,4.92-.05,1.55.02,3.04.88,4.4.82,1.29.55,2.82.66,4.22.3,3.68.33,7.39.55,11.08.08,1.4-.02,2.79,1.09,3.87.75.73.49,1.85,1.05,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.39,270.42c1.61-.45,2.63-.18,3.07,1.74.22.93,1.58,1.5,2.42,1.87,3.95,1.72,7.69,3.88,11.71,5.47,1.91.75,3.69.24,5.51.51,2.03.3,4.09.54,6.14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.71,338.17c-1.93-.34-3.76.38-5.62.59-2.52.29-5.07.5-7.58.97-1.95.37-2.31-.11-1.55-1.9.14-.33.07-.48-.03-.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M249.4,338.69c-.79,1.14-.14,2.35-.16,3.52-.05,3.81-.02,7.62-.02,11.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.45,71.59c.42.75.13,1.51.12,2.29-.06,3.87-.02,7.74-.03,11.61,0,.36.17.62.36.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.18,313.53c.5,1.54.67,3.15.69,4.75.05,3.28.01,6.57.01,9.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.65,43.08c-1.43-.34-1.9,1.06-2.78,1.64-2.36,1.57-4.47,3.5-6.71,5.25-.94.74-1.77.88-2.84.35-1.15-.58-2.46-.73-3.7-1.03-1-.24-1.65.03-2.23,1.31-.65,1.46-.72,2.82-.76,4.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267,313.36c0,4.05,0,8.09,0,12.14,0,.82.05,1.65-.18,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103,70.71c-1.08-1.6-1.11-3.57-1.87-5.31-1.29-2.96-3.46-5.22-5.37-7.69-.79-1.01-2.04-.52-2.95-.16-3.83,1.51-6.29,4.37-7.56,8.24-.43,1.31-.89,2.25-2.49,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.14,283.97c.65-.48.05-1.64,1.21-1.91.83.53.8,1.47.93,2.44.53,3.92.24,7.86.32,11.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.21,337.29c-1.95.44-3.87-.09-5.81-.16-4.14-.15-8.21.79-12.32.98-1.63.07-3.28.57-4.92.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.56,110.3c-1.28,0-2.33-.78-3.52-1.04-1.77-.38-3.52-.66-4.96,1.01-.51.6-.62.98-.55,1.79.27,3.22-.17,6.44-.12,9.67.01.65-.12,1.33.26,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.86,216.76c-2.04-.1-3.73,1.05-5.42,1.83-4.16,1.93-8.43,3.57-12.72,5.17-1.13.42-2.15,1.36-3.51,1.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.32,296.11c.1-3.99-.47-7.97-.02-11.97.09-.82.03-1.6,1.08-1.75,1.08-.16.46.9.88,1.23.33.26.5.61.54,1.05.31,3.81.12,7.63.17,11.44"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.86,
    y1: 124.2,
    x2: 46.71,
    y2: 127.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.42,41.85c.44,1.31.92,2.62-.7,3.52-.77.43-.73,1.18-.72,1.93,0,.66.25,1.72-.85,1.52-.75-.13-1.95-.19-1.95-1.52,0-.59,0-1.17,0-1.76,0-.97-.11-1.74-1-2.53-1.06-.95-1.42-2.53-1.4-3.98,0-.45,0-.84-.16-1.23-.22-.54-.48-1.24-1.13-1.19-.68.05-.8.73-.9,1.36-.11.69-.41,1.34-1.03,1.76l-5.81,2.64c-1.21-.29-1.69-1.08-1.59-2.29.07-.89-.18-1.57-.82-2.34-.94-1.14-1.63-2.48-1.52-4.18.11-1.69.91-3.27.37-5.14-.24-.82.33-1.86-.83-2.45-.09-.05-.04-.45,0-.68.18-1.45-.89-2.64-.88-4.05,0-.51-.39-.65-.71-.88-.15.31-.39.55-.54.87-.41.91-.06,2.22-1.38,2.68-.09.03-.11.61,0,.83.31.58.05.89-.36,1.25-1.19,1.03.19,2.89-1.23,3.88-.17.12.14.45.18.49,1.2.87.77,2.17.62,3.18-.18,1.18-1.17,2.15-1.52,3.35-.07.23-.32.17-.52.18-1.36.05-2.81-1.4-2.82-2.82,0-1.31.29-2.68-1.39-3.38-.8-.33-.85-1.36-1.02-2.09-.32-1.32-.9-2.6-.79-4.04.04-.56-.02-1.48-.84-1.53-.58-.04-.87.63-1.05,1.19-.18.58-.48,1.14-.53,1.76-.06.93-1.01,1.79-1.39,1.67-2.12-.66-2.07.74-2.12,2.02-.04.93-.62,1.04-1.24.86-2.55-.74-3.33-1.92-3.36-4.73,0-.73.38-1.75-.53-2.08-2.53-.93-2.73-2.93-2.62-5.14.02-.36-.28-.63-.32-.89-.3-2.06-1.32-4.17.29-6.17.29-.37.55-1.04-.16-1.38-1.44-.69-.26-1.58-.12-2.29.22-1.14-1.6-1.11-1.13-2.31.1-.26.29-.46.41-.67.38-.64.49-1.13-.21-1.61-.72-.5-.92-1.27-1.08-2.1-.14-.73-.94-.82-1.16-.33-.68,1.5-.98,3.18-1.98,4.55-.08.1.12.2.15.36.17.68.07,1.24-.22,1.97-.4,1-.03,2.32-.82,3.29-.31.38.09.45.2.52.69.46.5,1.14.52,1.78.05,2.09.18,4.19-1.2,6.01-.12.15-.28.52-.21.86.3,1.43-.47,2.42-1.6,2.95-1.76.84-2.18,2.2-1.9,3.9.2,1.22-.41,1.97-1.25,2.64-.78.63-1.41.46-1.55-.53-.1-.74-.24-1.17-1.09-1.06-.91.12-1.48-.23-1.4-1.23.05-.64-.37-.99-.71-1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.67,85.67c.82.77.13,1.65.14,2.46.07,3.4.11,6.81-.16,10.2-.05.67.03,1.15.72,1.41,1.75.66,3.42,1.56,5.28,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.58,39.21c.09.12.14.25.08.35-.93,1.67-.43,3.37-.2,5.11.42,3.18-1.25,5.71-3.01,8.06-1.03,1.37-.89,2.78-1.03,4.26-.25,2.82-.24,5.63.02,8.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.24,334.82c-4.23.22-8.43.77-12.67.94-.37.01-.71-.28-1.06-.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.58,201.09c-.52,4.04-.21,8.09-.24,12.14-.01,1.87-.13,2.01-1.96,1.78-3.91-.49-7.75-1.4-11.61-2.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M243.42,315.47h-.7c-3.12,0-3.16,0-3.32-3.17-.05-.92-.33-1.33-1.25-1.23-.12.01-.23,0-.35,0-4.04-.07-4.58.55-4.23,4.75.05.62.05,1.2-.88,1.07-.46-.07-.94-.06-1.4,0-1,.14-2.12.49-2.96-.07-.8-.53-.44-1.73-.51-2.59-.14-1.69-1.46-.93-2.19-1.15-.53-.16-1.27.25-1.91-.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.94,335.88c2.35,1.71,2.66,4.3,2.78,6.86.14,2.89.47,5.75.74,8.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.13,91.65c.75,1.35.19,2.82.35,4.22.21,1.87-.4,3.79.36,5.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125,108.54c-.88,1.57-.31,3.3-.44,4.93-.21,2.73-.31,5.51.09,8.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.61,91.82c-.19.26-.36.52-.36.88,0,3.75,0,7.51,0,11.26,0,.36.17.62.36.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.35,298.75c-.87,1.84-.78,3.88-1.2,5.81-.18.82.07,1.71-.55,2.47-.38.47-.34,1.01.17,1.39,1.77,1.3.9,2.99.7,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.66,344.5c-.38.25-.86.29-1.22.16-3.67-1.32-7.28.13-10.92.23-1.88.05-3.79.17-5.63.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.75,280.28c.12.17.23.45.36.51,3.63,1.52,7.19,3.21,10.73,4.94.33.16.68.24,1.05.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.46,40.09c-.27-1-.2-1.98-.03-3,.1-.61.17-1.29-.13-1.94-.37-.77-.97-1.15-1.77-1.03-.74.12-.73.8-.7,1.38.06,1.18-.31,2.34-.18,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.6,297.52c-.94.93-.43,2.1-.51,3.17-.08,1.05-.02,2.11-.01,3.17,0,.43-.15,1.02.53,1.04.62.01.9-.41.88-1.04-.02-.7,0-1.41,0-2.11,0-.44-.07-.91.35-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.12,258.28c-3.42-.8-6.93-.88-10.38-1.39-.59-.09-1.25-.18-1.76.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,339.57c-1.31,1.16-.51,2.69-.69,4.05-.4,2.98-.56,5.97-.19,8.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.63,334.65c-1.24,2.59-.4,5.29-.29,7.92.09,2.16-.2,4.38.46,6.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.18,346.26c-1.21.59-2.38-.04-3.51-.23-3.63-.6-7.16.38-10.74.47-1.09.03-2.27-.18-3.35.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.26,44.67c.31-1.52.12-3.05.18-4.57.01-.36-.07-.63-.35-.89-.56-.52-1.2-1.07-1.93-.82-.58.2-.36.99-.36,1.53-.01,1.11,0,2.23,0,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.45,49.95c-.24.33-.64.25-.87.15-1.03-.44-1,.14-1.09.9-.33,2.75-.38,5.51-.32,8.27,0,.32-.12.59-.19.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M262.07,316.7c.62.35.71.94.71,1.58,0,3.29-.07,6.57.17,9.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.64,313.36c.12,1.65.08,3.27-.09,4.94-.3,2.96-.25,5.99-.03,8.96.15,2.02.45,3.97-.02,5.99-.42,1.79,0,2.17,1.9,2.1,1-.04,2.05.26,2.99-.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.56,335c0,2.05.09,4.11-.02,6.16-.14,2.64-.3,5.28-.33,7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.25,325.85c-.09.23.2.3.19.53-.32,4.53.59,9.02.33,13.55-.05.84.73,1.6.19,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.14,295.76c-2.49-.22-4.93.26-7.39.55-.94.11-1.89.06-2.82.18-1.47.18-1.74.94-1.07,2.27,1.03,2.04,1.15,4.37,1.86,6.47.71,2.08,0,3.9-.08,5.84-.1,2.59.5,5.15.51,7.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.7,338.34c-.78.62-1.74.65-2.64.68-2.23.08-4.46.04-6.69.18-3.83.25-7.53-.74-11.26-1.38-.28-.05-.59,0-.88,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.42,55.93c.06-1.23-.11-2.47.16-3.7.09-.45.14-.96-.5-1.25-.47-.21-.97-.78-1.4-.63-.57.2-.58.94-.54,1.53.06,1.11-.48,2.23,0,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.88,346.79c-.08,2.3.09,4.59.39,6.86.22,1.65.04,2.06-1.62,2.12-2.63.1-4.83-1.24-6.98-2.39-1-.53-1.87-.9-2.87-.75-3.1.45-6.23.36-9.33.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.14,98.51c.76-.92.25-2,.31-2.99.14-2.19-.09-4.37-.66-6.51-.23-.87-.69-1.7-1.59-1.7-.89,0-1.07.86-1.27,1.7-.63,2.62-.63,5.27-.67,7.93-.05,3.02.21,6.05-.17,9.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.26,42.38c2.07.79,4.05,1.78,6.16,2.47.43.14.73.36,1.25.02,1.29-.83,2.87-.2,3.32,1.2.43,1.33,1.17,1.75,2.46,1.21,1.1-.46,1.69.04,2.11.9.91,1.87,1.41,2.02,3.36,1.44,1.02-.31,1.7.4,2.11,1.37.5,1.19,1.24,1.83,2.65,1.1.47-.24,1.37-.25,1.71.33.99,1.66,2.42,2.66,4.25,3.16.03,0,0,.22,0,.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.17,345.91c-1.38-3.22-1.32-6.64-1.2-10.03.11-3.24-.09-6.48-.46-9.67-.42-3.65.35-7.3-.41-10.93-.21-.98-.31-1.59-1.45-1.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.23,314.59c.89,1.22.85,2.63.89,4.05.09,3.05-.24,6.11.17,9.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.98,55.75c1.46,0,2.49-.54,2.83-2.11.23-1.08,1.2-1.61,2.09-1.52,1.05.11,1.44-.43,1.54-1.13.1-.67.45-1.12.93-1.19,1.16-.16,1.85-.75,2.29-1.79.3-.69.99-.5,1.57-.54.86-.05,1.36-.46,1.23-1.4-.13-.97.28-1.87.35-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.12,42.2c.68-.06.67.59.67.88.01,2.33.35,4.75-1.04,6.85-.53.8-.55,1.59-.53,2.48.05,2.34.02,4.69.02,7.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.91,285.2c-.84.35-1.84.07-2.36,1.38-.78,1.97-3.09,1.96-4.11,0-.82-1.57-1.92-1.76-3.39-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.99,259.16c3.06.46,6.1,1.07,9.14,1.62.48.09.95.04,1.41.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.53,39.92c-1.14.72-1.73,1.57-1.09,3.01.25.57.09,1.44-.34,1.89-1.1,1.15-1.07,2.5-1.03,3.9.02.59,0,1.2-.53,1.57-.48.34-.95,1.07-1.44-.15-.47-1.18-1.82-.12-2.6-.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.78,43.26c-.05-1.3.2-2.62-.42-3.88-1.54.5-1.8,1.7-1.71,3.18.06.94.21,1.93-.33,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.51,297.17c-3.46-.27-6.93-.44-10.38-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.74,253.35c-.24,2.18,1.34,3.96,1.31,6.16-.02,1.26-.01,2.68.77,3.89.2.31.22,1.01,0,1.37-.99,1.69-.55,3.52-.67,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.51,287.14c-2.87-.69-5.47-2.12-8.28-2.97-.61-.19-1.16-.91-1.93-.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.68,85.14c1.4,1.56,1.75,3.53,1.71,5.45-.11,5.63-.23,11.26-.47,16.89-.02.51-.18.9-.54,1.23l-.35,3.17c-.64.45-.53,1.12-.53,1.76,0,2.23,0,4.46,0,6.69,0,.64.11,1.31-.53,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.93,122.09c-.65.91-1.71,1.18-2.65,1.55-1.13.45-1.65,1.13-1.57,2.32.14,2.23-.25,4.45-.17,6.69.02.56-.09,1.04-.53,1.41l.09,4.4c.36,1.93.29,3.86.11,5.81-.05.55-.1,1.04-.55,1.41l.09,3.34c.17,1.77.08,3.37-1.08,4.97-1.2,1.64-.73,3.82-.92,5.76-.06.55-.1,1.04-.55,1.41l.09,3.7c.19,5.17-.11,10.33-.4,15.49-.14,2.57-.23,5.17.13,7.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.79,21.44c-.91-.06-1.05.87-1,1.22.27,2.03-.67,3.86-.76,5.81-.01.23,0,.47,0,.7-.02,1.06-2.24,1.8-.24,3.26.84.61.23,2.25.24,3.43,0,.8.32.87,1.07.73,1.31-.24,2.13.17,1.58,1.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.69,225.2c-3.4-.49-6.85-.6-10.21-1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.57,23.02c.3.92.59,1.77.4,2.82-.41,2.26-.28,4.57-.18,6.85.04.91-.22,1.76-.27,2.64-.07,1.26.63,2.29.65,3.52,0,.74,1.04.69,1.5.48.78-.35,1.47-.68,2.31-.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.45,291.01c-.65-.06-1.08.13-1.06.88.01.41.01.82,0,1.23-.01.43.15,1.03-.53,1.03-.43,0-.57-.42-.75-.84-.19-.45-.1-.84-.12-1.25-.08-1.76-.5-2.07-2.3-1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M333.69,299.81c.36,2.33.36,4.69.37,7.04,0,.53-.27,1.17.34,1.58.96.65,1.29,1.76,1.91,2.66.79,1.14,1.68,1.35,2.84.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.4,241.39c-.48.42-.73.9-.72,1.58.04,2.11.06,4.22,0,6.33-.03.85.39,1.19,1.08,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.23,299.46c.93.86,1.11,1.98,1.05,3.17-.03.7-.25,1.29-1.05,1.41-1.08.16-.81-.92-.81-1.23-.02-1.06-.48-2.24.46-3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.71,289.95c1.32.54.62,1.78.81,2.65.3,1.35-.02,2.8.23,4.21.17.93-.12,1.41-1.22,1.25-2.45-.35-4.95-.2-7.39-.69-.54-.11-1.2-.23-1.75.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.06,253c.95,2.25,1.49,4.5,1.32,7.04-.19,2.85-.47,5.77.26,8.62.03.11-.01.24,0,.35.19,1.28-.64,2.89.4,3.81,1.56,1.4,3.46,2.43,5.58,2.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.21,277.81c-3.23-.41-6.43-1-9.68-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.51,114.52c1.07-1.46.47-3.18.63-4.76.34-3.38.28-6.79.26-10.2,0-1.09-.34-2.12-.55-3.16-.15-.73-.4-1.47-1.39-1.41-.99.06-1.15.94-1.19,1.58-.11,1.75-.21,3.53-.17,5.28.08,3.85.47,7.71-.39,11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.64,316.52c1.04-1.49.14-3.05.13-4.57,0-.41-.65-.52-1.18-.55-3.78-.22-4.89.69-4.5,4.41.15,1.44-.33,1.41-1.31,1.43-.66.02-1.3-.21-1.93-.17-.63.05-.7-.41-.68-.73.05-.95-.25-1.87-.2-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.57,263.21c-2.43-.28-4.83-.7-7.22-1.2-.66-.14-1.43-.23-2.1.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.88,283.44c-.65,1.06-.43,2.25-.31,3.34.21,1.89-.58,3.62-.59,5.46,0,.34-.13.85-.68.69-.38-.11-.63-.49-.7-.87-.13-.72.29-1.57-.54-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.14,272.18c.12.28-.14.46-.19.7-.12.57.49,1.54-.69,1.57-1.14.03-.41-1.2-.9-1.54-.55-.38.52-1.77-.85-1.4-.83.22-2.47-.4-2.13,1.55.09.49-.2.76-.69.7-.5-.06-.89-.49-.85-.87.19-1.86-.87-2.1-2.32-1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.52,54.87c1.01.68,2.77.41,2.71,2.47-.02.69,2.07,1.18,2.73.69,1-.76,1.66-.24,2.1.56.73,1.31,1.34,2.44,3.21,1.62.83-.36,1.5.27,1.95,1.17.59,1.19,1.53,1.86,2.96,1.08,1.11-.6,1.54.25,1.92,1.05.29.62.58,1.01,1.42.93.47-.04,1,.29,1.44.79,1.25,1.41,2.48,3,4.71,2.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.77,262.33c-.35-1.81-.29-3.66-.1-5.45.1-.97-.41-2.19.76-3.09.75,1.53.27,3.13.38,4.66.12,1.71.2,3.43-1.22,4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.18,302.1c-3.23-.04-6.43.91-9.68.36-.32-.06-.59.08-.79.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.3,53.47c.23-.23.69-.49.67-.7-.25-2.52,1.77-2.99,3.39-3.46,2-.59,1.18-2.06,1.39-3.23.25-1.4-1.12-1.24-1.78-1.72-.34-.25-.69.17-.68.67.03.9-.15,1.77-.35,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.75,70.53c.91,2.71.98,5.37-.53,7.91-.48.8-1.18,1.12-2.1.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M254.33,354c-1.52.4-3.08.25-4.56-.06-.76-.16-.96.14-1.04.59-.21,1.09-.4,2.13-.82,3.2-.45,1.14.69,1.55,1.68,1.53,2.21-.05,4.39.33,6.6.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.71,346.79c.46,2.5-.19,5.08.52,7.57.1.36-.04.71-.17,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.46,203.03c.36,1.17.14,2.34,0,3.52-.27,2.4-.25,4.81-.14,7.21.05,1.09-.78,2.08-.22,3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.33,65.43c-.02,1.22.13,2.36,1.22,3.18.74.56.73,1.44.71,2.28-.05,2.15.09,4.25.73,6.35.38,1.24-.09,2.67.12,4.03.17,1.1.91,2.16.39,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.56,299.1c.4,1.51.06,3.05.18,4.57.04.48-.16.98.32,1.44.29.28.43.78.9.65.46-.13.85-.59.86-1.03.03-2.58.14-5.18-.33-7.74-.06-.32-.18-.6-.55-.71-.65.78-1.09,1.67-1.38,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.6,287.84c-.48,2.52-.09,5.05.03,7.56.12,2.41.08,4.81.15,7.22.06,2.23-.25,4.48.34,6.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M279.14,285.91c.01,2.29-.04,4.58.17,6.86.15,1.73-.23,2.13-1.92,2.1-1.79-.03-3.54.16-5.28.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.63,302.27c-.51,3.38.55,6.44,2.16,9.3.54.95.65,1.85.66,2.84,0,2.52,0,5.04,0,7.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.55,41.5c.08.42.54.65.38,1.24-.49,1.79-.09,3.63-.2,5.45-.01.18-.08.44,0,.52,1.97,1.79.91,4.11.97,6.17.04,1.38-.03,2.81-.1,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.98,285.38c.17,1.31-.02,2.52-.68,3.71-.69,1.23-.05,2.76-.73,4.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.04,346.79c-.19,2.17.33,4.38-.45,6.54-.08.22.23,1.21,1.31,1.47,2.22.53,4.37,1.36,6.71,1.32,1.4-.02,2.7.12,3.6-1.54.59-1.08,2.29-.52,3.44-.92,2.39-.85,4.71-.03,7.04.35,1.73.29,3.39.13,5.12-.3,1.38-.34,1.53-1.09,1.38-2.17-.07-.53-.37-1.02-.34-1.59.06-1.14-.57-1.31-1.4-.86-1.06.57-2.37.28-3.35,1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.94,252.65c-.21,1.69-.35,3.39-.35,5.1,0,1.12.06,2.24-.17,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.89,289.6c-2.17-.04-4.36.14-6.52-.33-.56-.12-1.19-.13-1.75.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.34,67.19c-.06,2.64-.82,5.28.98,7.8.76,1.07.34,2.78.21,4.16-.13,1.37-.17,2.7.04,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.72,347.67c.3,2.75.61,5.5.7,8.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.18,44.84c-.61,2.18-.53,4.29.52,6.34.19.38.45.72.37,1.23-.34,2.22-.23,4.45-.03,6.69.06.62.21,1.35-.69,1.58l-1.41,25.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.97,20.74c.74,1.09,1.09,2.42,1.6,3.59.47,1.09.87,2.59.68,3.98-.16,1.19.12,2.2,1.06,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.7,319.52c.24,1.17.47,2.35.68,3.52.29,1.59-.25,3.16-.33,4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.11,276.76c-2.3-.28-4.6-.56-6.87-1.04-.4-.08-.85.09-1.23.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.21,36.75c-1.16,1.08-1.78,2.63-3.16,3.53-1.12.72-.02,2.15-.88,2.99-.69.66-2.16.61-1.94,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.85,74.58c.49-1.12-.43-2.08-.42-3.17,0-.3-.41-1.2-1.16-1.04-.98.21-1.41.95-1.6,1.91-.48,2.5-.75,5.02-.69,7.57,0,.29.13.65.12.88-.07,2.22-.1,2.22,1.98,2.99,1.68.63,1.76.64,1.92-1.06.24-2.63.34-5.28.02-7.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.82,290.13c.62.35.71.94.71,1.58-.01,1.35.04,2.7-.02,4.05-.05,1.18.5,1.58,1.6,1.59,1.86.03,3.76-.32,5.48.84.46.31,1.01-.08,1.21-.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.82,299.28c2.62.5,5.3.44,7.92.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.51,285.38c-.71,0-1.37-.19-1.21-1.05.27-1.5-1.09-1.41-1.8-1.91-.22-.15-.88-.26-1.02.32-.26,1.1-.88.65-1.6.57-1.07-.13-.94-.83-.86-1.45.21-1.45-.95-1.43-1.78-1.76-.72-.29-1.48-.71-1.77.52-.1.43-.48.05-.7.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.76,261.27c.12.12.33.23.34.35.17,3.03,2.8,3.78,4.78,5.08,1.39.91,2.71,1.94,4.21,2.65.49.23.96.64.84,1.06-.76,2.55,1.12,1.82,2.32,1.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.39,88.13c-.3,2.22.36,3.12,2.46,3.35.68.07.8-.24.91-.88.3-1.6-.04-3.17-.04-4.76,0-1.94.14-3.89-.34-5.81-.23-.92-.48-2.26-1.4-2.18-1.11.1-1.42,1.41-1.41,2.53,0,1.89-.41,3.74-.35,5.63.02.65-.12,1.31.17,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.54,312.48c0-.76,0-1.52,0-2.29,0-.44.08-.96-.53-1.04-.75-.1-1.11.29-1.06,1.04,0,.12-.02.24,0,.35.61,3.56.23,7.16.46,10.74.08,1.19.5,1.94,1.29,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.12,294.35c-2.66.08-5.27-.48-7.92-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.88,51.71c-1.01.02-1.62,1.04-2.64,1.07-.22,0-.18.31-.18.51-.01,2.29.05,4.58-.15,6.86-.02.19.29.43.33.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.72,267.96c-1.12-.07-.9-.91-.87-1.58.04-1.03-.55-1.31-1.42-1.42-1.02-.12-1.14.44-1.07,1.24.04.43.08,1.05-.52,1.01-.41-.03-1.09-.22-.89-1.01.14-.57-.16-1.13-.39-1.56-.42-.77-1.38-.28-2.09-.48-.34-.1-.52.67-.51,1.16,0,.43.1.97-.53,1.05-.75.1-1.1-.29-1.06-1.05.07-1.24-.42-1.93-1.76-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.11,281.51c1.87.28,3.77.31,5.64.67.67.13,1.48.26,2.11-.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.98,105.2c.45-1.39.11-2.82.15-4.22.08-3.52.24-7.04.39-10.56.05-1.14-.25-2.24-.42-3.34-.3-1.99-1.62-2.5-3.46-1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.37,36.57c0-1.23-.01-2.46,0-3.7,0-.63-.21-1.46.54-1.72.79-.28,2.44.92,2.43,1.72-.02,1.58.22,3.18-.16,4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.4,320.22h-7.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.58,246.14c.65.55,1.06,1.32.85,2.1-.55,1.99.67,3.64.91,5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.18,247.55c-1.86.55-3.64-.17-5.45-.39-.67-.08-1.29-.26-1.94.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.26,323.39c-.49,1.27-.79,2.54-.18,3.87.34.74-.3,2.39-1.05,2.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.24,251.24c-2.21.18-4.35-.34-6.51-.69-.28-.04-.64-.17-.88.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.18,298.58c2.46.37,4.93.17,7.39,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.1,291.01c-.65,1.06-1.72,1.69-2.64,2.46-1.26,1.05-1.95.95-2.99-.34-.55-.68-.98-1.9-1.9-1.66-.63.16-.18,1.46-.41,2.17-.66,2.08,0,4.27-.63,6.36-.24.79-.13,1.73.49,2.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.38,285.2c1.33,2.54,1.79,5.28,1.55,8.09-.16,1.85-.22,3.65.21,5.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.45,87.6c-2.26-.45-4.23-1.63-6.35-2.43-.2-.07-.57-.5-.87-.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.94,265.67c-1.45.01-2.65-.31-2.64-2.11,0-.5-.22-.78-.71-.7-2.14.39-3.95-.37-5.64-1.58-.16-.11-.46-.01-.69-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.38,298.93c-1.35,1.9-2.01,4.05-2.28,6.34-.06.53.08,1.08-.18,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.06,285.38c.02.91,0,1.77.49,2.66.88,1.61,1.3,3.41.91,5.25-.49,2.3.12,4.58,0,6.87-.02.34.15.51.36.7,1.38,1.26,1.15,3.11,1.11,4.57-.06,2.27.32,4.46.47,6.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.92,278.34c-.13,2.13-.99,4.13-.96,6.34.02,1.37.13,2.86-.45,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.19,46.78c.38-1.63.14-3.29.15-4.93,0-.8-.69-1.01-1.38-1.06-.84-.05-.61.57-.72,1.05-.28,1.29-.1,2.58-.16,3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.96,256.35c-.16.25-.52.33-.53.7-.08,2-.87,4-.46,5.97.36,1.74.28,3.41.11,5.11-.01.12,0,.24.18.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.36,173.12c-2.02-.02-3.87-.82-5.8-1.26-.4-.09-.71-.25-1.06.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.2,264.26c1.44,1.32,1.19,3.07,1.24,4.75.08,3.29.51,6.57.49,9.85-.02,2.23.57,4.46.04,6.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.3,170.13c-1.55.11-2.89-.75-4.39-.96-.82-.11-1.65-.2-2.48-.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.47,311.42c-.42-.03-.8.19-1.23.2-2.51.04-3.09.71-2.82,3.15q.23,2.11-1.76,2.11c-.35,0-.7,0-1.06,0q-2.04,0-2.29-2.11c-.24-2.07-.53-2.33-2.64-2.09-.53.06-1.05.14-1.59.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.74,261.45c.35,1.41,1.64,1.88,2.64,2.64,1.14.86,2.52,1.47,2.99,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.98,255.82c.55,2.7,1.86,5.18,2.31,7.92.05.29.5.4.35.89-.87,2.91.19,5.87-.19,8.79-.18,1.36.37,1.98,1.76,1.76.77-.12,1.51.29,2.29.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.22,36.4c-1.73,1.19-3.23,2.65-4.92,3.88-.56.41-1.05.96-1.07,1.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.42,25.66c-.31.37-.64.64-.74,1.22-.37,2.01-.35,4.12-1.85,5.85-.68.79-.24,2.08-.33,3.13-.1,1.1-.41,1.72-1.47,1.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.6,278.52c-2.18.11-4.29-.91-6.52-.39-.31.07-.32-.51-.34-.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.68,43.26c-1.3,0-1.76.71-1.78,1.94-.02,1.23.21,2.48-.16,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.06,57.34c-.12-1.07.19-2.11.18-3.17,0-.59-.09-1.18.88-1.08.84.09,1.23.34,1.25,1.26.02,1.47-.23,2.95.16,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.12,244.73c.32,1.76,1.09,3.51.01,5.29-.23.38.19.8.16,1.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.36,134.76c-1.7.03-3.16-.83-4.75-1.23-.57-.14-1.12-.63-1.76-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.34,264.97c-.4,1.26-.22,2,1.19,2.72,1.84.94,3.9,1.76,5.14,3.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.23,36.22c0-.59.1-1.19-.03-1.75-.13-.61.61-1.77-.68-1.71-.93.04-1.45.8-1.43,1.88.02,1.23.22,2.48-.15,3.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.9,346.26c-.1,2.11.21,4.23-.18,6.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.34,282.21c-2.1-.29-4.23-.24-6.33-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.05,270.25c.7.46,1.87-.27,2.2.56.2.51-.14,1.38-.08,2.08.27,3.1.48,6.21.34,9.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.57,272.01c-.77-.42-1.42-.84-1.45-1.93-.03-1.05-1.48-1.59-3.3-1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.97,272.36c.79.56.91,1.35,1.13,2.27.49,2.1-.03,4.39,1.14,6.36.1.16.02.45-.14.71-.64,1.02-.55,2.19-.55,3.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.76,312.48c.6,2.02.59,4.09.53,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.19,53.47c-1.3.13-1.61.98-1.59,2.11.02,1.17,0,2.35,0,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.42,127.02c.27,2.05-.5,4.11.09,6.16l1.8-3.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.02,43.44c1-.77,2.2-1.18,3.36-1.54,1.34-.41,1.42-1.09.66-1.96-.6-.7-.76-1.29.04-1.75.68-.39.93-.74.51-1.44-.43-.72-1.09-.81-1.76-.51-1.62.72-3.15,1.64-4.93,1.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.49,330.6c3.81-.2,7.61-.59,11.44-.54.76.01.91.36,1.09,1.05.5,1.82.22,3.65.32,5.47.04.66-.2,1.37.35,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.96,252.65c-.41,2.97,1.29,5.49,1.74,8.27.42,2.56.28,5.16.36,7.74.05,1.46,0,2.93.02,4.4,0,.36.02.77.52.88.64.15.57-.49.67-.72.43-.96,1.29-.59,1.78-.44.62.18,1.69.12,1.63,1.34-.02.45-.31,1,.31,1.42,1.7,1.15,1.45-.6,1.95-1.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.03,344.5c-1.08.13-2.14-.06-3.16-.37-2.31-.7-4.46.42-6.69.6-.87.07-1.75.29-2.64.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.89,339.05c1.85.82,3.89.72,5.81,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.14,342.57c-1.31.41-2.56-.3-3.87-.29-.54,0-1.29-.1-1.94-.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M337.56,349.96c-1.32.59-2.66.11-3.85-.25-1.55-.46-2.98-.26-4.41.11-1.06.27-2.13.29-3.18.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.57,47.13c1.24-.07,1.79.52,1.77,1.76-.02,1.01-.1,2.01-.36,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.47,348.55c1-.63,2.19-.54,3.15-.27,1.09.3,2.13.16,3.19.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.59,93.23c.82.17.9-1.33,1.74-.85.73.42.88,1.27,1.09,2.08.69,2.68.19,5.4.31,8.1.13,2.93,0,5.86.03,8.8,0,.35-.52.47-.36.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.97,264.44c1.88-.18,3.73.33,5.64.04,1.56-.24,2.98.57,4.39,1.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.84,264.26c-1.06,1.05-.5,2.48-.84,3.7-.14.51-.11,1.08-.39,1.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.3,47.31c.75,1.26-.04,2.42-.43,3.49-.22.6-.45,1.15-.45,1.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M335.27,288.55c-.64-.45-1.47-.35-2.12-.44-2.35-.32-3.95-1.09-3.88-3.79,0-.4-.38-.75-.68-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.4,216.4c1.82.06,3.49.85,5.28,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.38,186.84c-1.45-.2-2.85-.56-4.22-1.05-.31-.11-.59.1-.88.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.01,301.04c1.96,1.22,1.11,3.28,1.31,4.94.11.91-.93,1.72-2.19,1.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.33,71.59c.55-1.07-.1-1.95-.55-2.81-.69-1.3-1.51.15-2.27-.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.68,151.47c-1.71.11-3.23-.88-4.93-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.44,280.63c2.05-.47,4.01.1,5.98.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.55,52.23c.71,1.48.24,3.05.34,4.58.1,1.58-.13,3.18.19,4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.6,317.76c-.85-.88.32-2.56-1.23-3.17-1.38,1.41.37,3.29-.71,4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.43,299.1c1.9-.76,3.77-.26,5.63.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.33,353.3c-1.62-.16-3.17.3-4.75.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M336.68,284.85c0,.35.15.84-.02,1.04-1.68,1.92-1.01,4.07-.67,6.18.21,1.3.27,2.58-.01,3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M271.93,324.62c.8.86.09,2.03.62,3.03.24.46-.62.34-1.15.36-3.7.15-7.44-.04-11.09.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M330.7,344.5c.3,2.81,1.24,5.56.88,8.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.71,53.11c-1.64-.46-2.88-1.77-4.57-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.58,353.21c.24-.78.14-1.58.18-2.38.07-1.38.61-1.81,1.93-1.59.11.02.24-.03.35,0,1.31.4,3.15-.23,3.82,1.42.55,1.36.33,2.91.05,4.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.06,36.05c-.09-.23.16-.48.19-.5,1.03-.66,1.53-1.3.94-2.7-.42-1,1.71-1.29,1.31-2.6-.05-.17-.16-.34-.15-.53l1.41-.7c.62.77.73,1.74.84,2.64.09.75.34,1.35.75,1.93l1.06,5.45c-1.58,2.51-1.48,6.27.17,8.8,1.07,1.64,1.77,3.37,1.63,5.45-.17,2.51-.04,5.04-.04,7.56,0,.7.09,1.41-.53,1.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.58,245.26c-.23,1.65-1.46,2.93-1.52,4.75-.04,1.3-.22,2.76-.77,4.05-.54,1.26-.32,2.42.1,3.72.36,1.12.07,2.44.07,3.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.28,297.87c1.16.52,1.58,1.72,2.04,2.68.64,1.34,1.45,1.59,2.72,1.38.69-.11,1.43.13,2.11-.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.1,346.79c-1.52-.22-3.05-.17-4.57-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.56,247.9c-1.64-.29-2.98.92-4.57.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.44,270.77c-.66.09-1.41.08-1.91-.22-1.24-.74-1.57.06-1.96.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.33,274.82c-2.2-.23-4.27-1.18-6.51-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.7,262.15c-1.67-1.07-3.49-.62-5.28-.54-.73.03-.79.59-.86,1.07-.08.51-.02,1.05-.02,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.67,36.93c1.18-1.18.5-2.9,1.2-4.24.18-.34.19-.82.38-1.22.37-.78.63-.74,1.09-.01.29.46.48.89.51,1.42.03.65-.29,1.42.69,1.79.55.21.22.83.16,1.2-.25,1.4,1.15,2.45.79,3.89-.04.16.49.76,1,.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.88,337.64c1.36.84,3.02.14,4.4.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.53,345.73c-1.3,1.02-2.82.33-4.22.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.67,324.09c.56,1.35.72,2.77.7,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.78,293.83c2.53,1.03,2.99,3.55,4.03,5.64.12.25.11.58.37.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.2,283.27c.08,2.21-.65,4.21-1.58,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.89,287.49c-1.06,1.12-1.12,2.59-.81,3.85.35,1.42.04,2.86.46,4.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.26,56.46c.88-.36,1.54-.48,1.43.88-.09,1.05-.02,2.11-.02,3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.89,289.07c-.23-.52-1.21-.47-1.04-1.23.48-2.17-1.3-2.01-2.48-2.46-.21-.08-.67-.04-.67,0-.27,1.7-1.64.76-2.49,1.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M364.13,344.15c-1.35.81-2.7.05-4.05,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.08,315.47c.73.22.7.82.71,1.41.02,1.11-.14,2.09,1.15,2.94.66.44.54,2.14-.1,3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.18,253.35c-.58,1.61-.8,3.32-1.41,4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.16,296.29c-.09-1.06.1-2,.86-2.83.72-.78,1.08-1.76.53-2.79-.52-.98-.42-2.24-1.39-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.62,97.46c.86.18,1.65.72,2.47.82,1.31.16,1.33.95,1.21,1.82-.3,2.17-.11,4.34-.15,6.51,0,.37-.06.72-.19,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.94,261.45c-.41,0-.83.04-1.23,0-1.38-.16-1.68.59-1.59,1.77.12,1.58.35,3.17,0,4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.74,68.42c-1.12.78-2.08,1.95-3.7,1.58l-1.23,2.11c-.71,1.22-.51,2.56-.53,3.87-.01.88.09,1.77-.17,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.84,306.14c.2,1.39.76,2.65,1.41,3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.22,315.29h-3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.62,76.69c-.74.16-1.35-.18-1.93-.54-.61-.37-1.18-.78-1.94-.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.78,308.96c0,1.3.58,2.55.35,3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.27,276.76c.44,1.19-.41,3.06,1.82,3.27.4-.48.27-1.69,1.53-1.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.87,277.46c1.31-.07,2.6.06,3.87.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.68,295.58c-1.23-.43-2.46.61-3.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.98,96.4c-1.21-.43-2.47-.69-3.7-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.64,335.18c1.12.83,2.49.31,3.7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.51,79.16c-1.36.11-2.36-1.06-3.7-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.85,307.37c-1.23.58-2.46-.17-3.7,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.82,75.81c1.36-.1,2.38,1.01,3.7,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.94,75.99c.66-.05,1.26-1.04,1.91-.33.83.92,1.24,2.05.73,3.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.2,207.34c-2.87-.38-5.13,1.13-5.63,3.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.82,291.19c-.59,1.21-2.02,2.05-1.58,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.32,302.27c.21,1.25.5,2.51-.88,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.16,90.59c-1.24-.04-2.26-.92-3.52-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.42,345.21c-.93,1.03-.25,2.39-.7,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.33,78.28c1.25.18,2.26,1.08,3.52,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.82,42.03c.9-1.13,1.92-1.03,3.19-.58.69.25,1.41.46,2.09.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.81,101.68c-1.23.05-2.26-.9-3.52-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.33,80.74c1.2.26,2.36.67,3.52,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308,308.96c-1.02.01-.87.76-.88,1.41-.01.59.31,1.15.18,1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86.46,92.7c1.22.21,2.28.93,3.52,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M90.51,74.4c-1.25-.18-2.26-1.08-3.52-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.05,311.25c-1.15.53-2.74-.45-3.61,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.14,96.05c-1.23-.15-2.27-.96-3.52-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.66,260.74c.09,1.17-.15,2.36.18,3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.81,99.04c-1.24-.04-2.26-.92-3.52-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.54,53.11c.24,1.28.16,2.58.18,3.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.03,42.56c0,1.41,0,2.82,0,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.5,75.81c1.16.2,2.1,1.11,3.34,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.8,91.82c1.12.33,2.19.81,3.34,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M250.28,313.18c-2.11,0-4.22,0-6.33,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.98,48.89c-.26-.35.02-.71-.01-1.05-.06-.54.37-1.41-.69-1.39-.69.02-.98.48-1.09,1.21-.08.53-.12,1.06-.14,1.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.62,100.45c1.18-.01,2,1.03,3.17,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.75,86.37c-1.16.1-2.05-.82-3.17-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.62,102.91c1.12-.06,1.99,1.01,3.17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.94,78.28c.84-.01,1.44.71,2.29.72.93.01.89.72.89,1.39-.01,2.46,0,4.93,0,7.39,0,1.34-.34,1.56-1.58,1.05-.63-.26-1.2-.68-1.94-.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.75,83.91c-1.16.09-2.07-.74-3.17-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.4,106.25c-1.03-.09-1.88-.96-2.99-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.76,80.56c1.03.17,1.88.97,2.99.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.85,283.62c1.57.19,1.4,1.38,1.41,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.22,274.82c0,.35-.03.71,0,1.05.06.5.09,1.13.54,1.38.55.3.79-.38,1.01-.69.42-.57.84-.33,1.25-.15,1.14.51,1.68,0,1.94-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.67,74.58c-1.03-.25-1.96-.81-2.99-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.18,309.13c.88.78.52,1.72.35,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.41,107.84c1.01.18,1.92.77,2.99.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.4,97.63c-1.05-.11-1.88-.98-2.99-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.55,343.8c-1.15-.06-2.27.11-3.34.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.56,86.19c-1.05,0-1.92-.8-2.99-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.02,313c-1.38.46-2.84-.08-4.22.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.34,267.43c-.45.96.11,2.04-.35,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.18,300.16c-1.92.38-3.91.13-5.81.68-.46.13-1.01.08-1.49-.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.41,102.91c1.09-.18,1.9.87,2.99.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.17,335.7q.63,2.84,3.34,2.82c.65,0,1.29,0,1.94,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.22,46.78c-.35,1.09-.17,2.29-.7,3.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.07,246.67c.73.81.11,1.97.7,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.7,38.68c-.58,1.05.6,1.59.74,2.46.15.96.84,1.32,1.9,1.29.78-.02.9.94,1.23,1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.35,299.63c.52.98,1.81,1.48,1.76,2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.38,40.09c.07.52.7,1.13-.52,1.28-.85.1-1.45,1.11-2.47,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.58,302.8c-1.3-.54-2.54-.69-3.52.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.61,106.43c-2.49,1.33-4.6,3.27-7.21,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.59,100.09c1.02.05,1.87.62,2.82.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.28,307.2c.43,1.54-.04,3.05-.18,4.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M280.9,271.83c.83.46,1.81-.12,2.64.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.03,103.09c-.99.2-1.67-.8-2.64-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.79,308.96c.06,1.41.49,2.79.35,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M314.86,298.22c-.95.43-1.98.42-2.99.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.36,349.08c.28.87.63,1.72.7,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.39,83.91c-.99.03-1.65-.91-2.64-.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.82,287.31c-.46.45-.53,1.13-.31,1.57.54,1.11-.28,1.27-.92,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.64,238.93c-.79.81-1.7,1.53-2.11,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.49,122.09c.41.8.75,1.62,1.06,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.14,310.37c.68-.38,1.35-.72,1.41.53.02.53-.06,1.08.18,1.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.57,99.04c.88.03,1.54.81,2.46.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M288.12,307.55c.01,1.44.54,2.8.7,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.57,105.37c.9-.03,1.57.74,2.46.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.37,122.09c.11.82-.47,1.64,0,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.95,125.03c-.26.81-.58,1.61-.7,2.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.57,130.71c.86,0,1.53.85,2.46.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.92,80.91c.94-.19,1.52.89,2.46.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.14,319.52c-.88,2.21.33,3.69,1.76,5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.61,142.12c-.27.42-1.04.81-1.32,1.23"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 45.41,
    y1: 143.74,
    x2: 45.41,
    y2: 146.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.22,72.29c.91.1.86-.67.66-1.03-.33-.58-.87-1.14-1.72-.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.01,219.92c.58.65,1.2,1.29.88,2.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.49,342.74c3.13-.51,3.11-.51,3.72,2.81.06.34.29.68.33,1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.86,108.72c-.74-.41-1.41-.96-2.29-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.25,130.71c-1.88.2-3.37.83-3.71,2.99-.13.81-.78,1.23-1.57,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.87,51.35c-.02-.48.14-1.13-.53-1.2-.42-.04-.66.44-.89.84-.82,1.44-1.48,2.99-2.63,4.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.83,267.43c-.16.75.28,1.4.35,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.71,343.45c-.32.7.04,1.41,0,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.06,134.89c.67.24,1.38.32,2.11.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.73,135.99c-.74.14-1.42.42-2.11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.52,307.55c.33,1.39.44,2.82.7,4.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.41,141.44c.4.66.54,1.43.88,2.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.89,141.8v2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.57,110.12c.73.15,1.33.72,2.11.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.12,344.15c-.68.26-1.44.21-2.11.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M349,292.24c1.94.4.86,2.14,1.41,3.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.56,88.66c-1.04-.07-1.96-.61-2.99-.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.89,
    y1: 133.49,
    x2: 49.95,
    y2: 133.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 43.42,
    y1: 127.19,
    x2: 44.65,
    y2: 128.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.91,
    y1: 134.21,
    x2: 40.98,
    y2: 134.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.65,291.89c-1.24.61-2.23-.32-3.34-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.24,312.3c.87.28,1.55,1.25,2.64.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.95,
    y1: 130.74,
    x2: 43.7,
    y2: 131.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.11,299.28c.96.66,2.02-.26,2.99.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M74.32,37.1c-.34.41.12.82,0,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.41,347.67h-1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M322.25,306.32c-.42,1-.9,1.53-1.98.57-.25-.22-.74-.49-1.19-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.29,338.17c-.89.79-2.05.04-2.99.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.81,70.53c-.59.04-.08,1.63-1.23.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.3,336.58c.7-.05,1.41,0,2.11,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.48,281.51c-.24-.04-.53.11-.7-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.92,303.5c-.17.21-.31.43-.35.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.09,280.28c-1.1.56-1.21,1.66-1.2,2.64.04,3.23-.25,6.45-.21,9.68.02,1.56,1.01,2.22,2.47,1.78.65-.2.52-.64.52-1.07,0-3.4.04-6.8-.02-10.21-.02-1.09-.4-2.13-1.38-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.7,313.18c-.85.31-.88,1.01-.89,1.76,0,6.05-.08,12.09.52,18.13.03.31.11.59.19.88.16.51.49.75,1.05.71.75-.04.71-.56.7-1.06-.02-1.64.02-3.28-.16-4.93-.39-3.51-.04-7.04-.23-10.55-.09-1.66.09-3.45-1.02-4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.94,159.74c-.43.24-.91.35-.9,1.06.05,2.05.02,4.11.01,6.16,0,.42,0,.89.53.85.34-.03.86-.22.87-.67.05-2.47.58-4.96-.34-7.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.74,310.72c-1.13.99-1.2,2.38-1.21,3.7-.05,5.51-.12,11.03.03,16.54.05,1.99-.04,4,.3,5.98.28,1.63,1.51.7,2.3.84.84.15,1.29-.23.9-1.21-.14-.35-.03-.81-.02-1.22.09-7.04-.28-14.08-.38-21.11-.02-1.37-.21-2.82-1.73-3.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.78,296.82c-.28-.05-.5.23-.51.35-.03,2.23,0,4.46-.04,6.69,0,.47.3.77.55.84.34.08.64-.28.69-.66.3-2.34.31-4.69,0-7.04-.03-.23-.32-.19-.52-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.02,302.62c-.84.38-1.06,1.09-1.06,1.94,0,1.29.01,2.58,0,3.87-.01.97.44,1.53,1.41,1.58,1.11.05,1.29-.68,1.23-1.58-.12-1.65.3-3.33-.49-4.94-.23-.47-.33-.86-.92-.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.3,
    y1: 137.94,
    x2: 40.41,
    y2: 138.56
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.8,
    y1: 125.43,
    x2: 94.73,
    y2: 126.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.75,
    y1: 126.89,
    x2: 105.84,
    y2: 125.34
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.4,
    y1: 130.1,
    x2: 108.63,
    y2: 129.41
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50.39,
    y1: 80.52,
    x2: 52.15,
    y2: 79.11
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.86,
    y1: 88.08,
    x2: 50.92,
    y2: 89.33
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.19,
    y1: 89.57,
    x2: 108.11,
    y2: 91.19
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.02,
    y1: 90.38,
    x2: 95.79,
    y2: 91.69
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.93,
    y1: 91.68,
    x2: 48.98,
    y2: 93.27
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46.41 80.18 45.99 86.07 47.45 81.78"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 50.02,
    y1: 129.89,
    x2: 51.78,
    y2: 128.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.49,
    y1: 137.45,
    x2: 50.55,
    y2: 138.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 105.82,
    y1: 138.93,
    x2: 107.74,
    y2: 140.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 96.65,
    y1: 139.74,
    x2: 95.42,
    y2: 141.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 47.56,
    y1: 141.04,
    x2: 48.61,
    y2: 142.63
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46.04 129.55 45.62 135.43 47.08 131.15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinster);
export default __webpack_public_path__ + "static/media/minster.8b0f6de9295bb0a58104fc5e39ad7778.svg";
export { ForwardRef as ReactComponent };